if (!customElements.get('contract-information')) {
    class ContractInformation extends HTMLElement {
        constructor() {
            super();
            this.form = null;
            this.addressDisplay = null;
            this.boundHandleDefaultAddressUpdate = null;
            this.boundHandleChangeAddressClick = null;
            this.gmoOrderCheckStatusInterval = null;
            this.ethOrderCheckStatusInterval = null;
            this.expireTimeInterval = null;
            this.ethOrderId = null;
            this.pendingElectronicAction = null;
            this.noElectronicListenerAttached = false;
            this.handleNoElectronicClick = this.handleNoElectronicClick.bind(this);
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            // Clean up event listeners if needed
            if (this.form) {
                this.form.removeEventListener('submit', this.handleSubmit);
            }
            if (this.boundHandleDefaultAddressUpdate) {
                document.removeEventListener('customer:default-address:updated', this.boundHandleDefaultAddressUpdate);
            }
            if (this.boundHandleChangeAddressClick) {
                const changeBtn = this.querySelector('#change-default-address');
                if (changeBtn) {
                    changeBtn.removeEventListener('click', this.boundHandleChangeAddressClick);
                }
            }
            if (this.noElectronicListenerAttached) {
                document.removeEventListener('click', this.handleNoElectronicClick);
                this.noElectronicListenerAttached = false;
            }
        }

        init() {
            this.form = this.querySelector('#contract-information-form');
            if (!this.form) return;

            // Initialize accordion functionality
            this.initAccordion();

            // Initialize edit confirm contract button (always initialize as it's in a separate popup)
            this.initEditConfirmContract();
            // Initialize edit address contract popup
            this.initEditAddressContractPopup();

            // Toggle representative fields based on checkbox

            // Handle form submission
            this.handleSubmit = this.handleSubmit.bind(this);
            this.form.addEventListener('submit', this.handleSubmit);

            // Listen for default address updates
            this.addressDisplay = this.querySelector('.customer_default_address address');
            this.boundHandleDefaultAddressUpdate = this.handleDefaultAddressUpdate.bind(this);
            document.addEventListener('customer:default-address:updated', this.boundHandleDefaultAddressUpdate);

            const deliveryEmailInput = this.form.querySelector('#delivery-email');
            if (deliveryEmailInput && !deliveryEmailInput.hasAttribute('data-validity-listener')) {
                deliveryEmailInput.setAttribute('data-validity-listener', 'true');
                deliveryEmailInput.addEventListener('input', () => {
                    deliveryEmailInput.setCustomValidity('');
                });
            }

            const receiveContractCheckbox = this.form.querySelector('#is-receiving-contract');
            if (receiveContractCheckbox && !receiveContractCheckbox.hasAttribute('data-validity-listener')) {
                receiveContractCheckbox.setAttribute('data-validity-listener', 'true');
                receiveContractCheckbox.addEventListener('change', () => {
                    if (receiveContractCheckbox.checked) {
                        receiveContractCheckbox.setCustomValidity('');
                    }
                });
            }

            const changeAddressBtn = this.querySelector('#change-default-address');
            if (changeAddressBtn) {
                this.boundHandleChangeAddressClick = this.handleChangeAddressClick.bind(this);
                changeAddressBtn.addEventListener('click', this.boundHandleChangeAddressClick);
            }

            const addNewAddressBtn = this.querySelector('#add-new-address');
            if (addNewAddressBtn) {
                addNewAddressBtn.addEventListener('click', () => {
                    const addAddressDrawer = document.querySelector('#add-address-drawer');
                    if (addAddressDrawer) {
                        addAddressDrawer.setAttribute('open', '');
                        addAddressDrawer.setAttribute('aria-hidden', 'false');
                        document.querySelector('#addresses-drawer').setAttribute('open', '');
                        document.querySelector('#addresses-drawer').setAttribute('aria-hidden', 'false');
                        const overlay = document.querySelector('.js-overlay');
                        if (overlay) {
                            overlay.classList.add('is-visible');
                        }
                    }
                });
            }

            const confirmElectronicBtn = document.querySelector('#confirm-contract-electronic-btn');
            if (confirmElectronicBtn && !confirmElectronicBtn.hasAttribute('data-listener')) {
                confirmElectronicBtn.setAttribute('data-listener', 'true');

                const electronicHolderInput = document.querySelector('#electronic-holder-name-confirm');
                if (electronicHolderInput && !electronicHolderInput.hasAttribute('data-validity-listener')) {
                    electronicHolderInput.setAttribute('data-validity-listener', 'true');
                    electronicHolderInput.addEventListener('input', () => {
                        electronicHolderInput.setCustomValidity('');
                    });
                }



                confirmElectronicBtn.addEventListener('click', () => {
                    const holderNameInput = this.form?.querySelector('#holder-name');
                    const confirmInput = document.querySelector('#electronic-holder-name-confirm');

                    if (holderNameInput && confirmInput) {
                        const originalName = (holderNameInput.value || '').trim();
                        const confirmName = (confirmInput.value || '').trim();



                        if (!confirmName) {
                            const msg = theme.strings.contract.msg_required_holder_name;
                            confirmInput.setCustomValidity(msg);
                            confirmInput.reportValidity();
                            confirmInput.focus();
                            return;
                        }

                        // if (originalName && confirmName && originalName !== confirmName) {
                        //     const msg = theme.strings.contract.msg_notmatch_holder_name;
                        //     confirmInput.setCustomValidity(msg);
                        //     confirmInput.reportValidity();
                        //     confirmInput.focus();
                        //     return;
                        // }

                        // Clear any previous error
                        confirmInput.setCustomValidity('');

                        // Update hidden electronic holder name field to keep confirmed value (use the confirmed input value)
                        const hiddenElectronicName = this.form?.querySelector('#electronic-holder-name');
                        if (hiddenElectronicName) {
                            hiddenElectronicName.value = confirmName;
                            this.setCookie("electronic-holder-name", confirmName,90);
                        }
                    }

                    // After successful confirmation, actually switch delivery method to electronic
                    const electronicRadio = this.form?.querySelector('input[name="contract_delivery_method"][value="electronic"]');
                    if (electronicRadio) {
                        electronicRadio.checked = true;
                        this.toggleDeliveryFields();
                    }

                    popupClose('popup_electronic_confirmation');
                    if (typeof this.pendingElectronicAction === 'function') {
                        const action = this.pendingElectronicAction;
                        this.pendingElectronicAction = null;
                        action();
                    }
                });
            }

            if (!this.noElectronicListenerAttached) {
                document.addEventListener('click', this.handleNoElectronicClick);
                this.noElectronicListenerAttached = true;
            }

            // Handle delivery method toggle
            this.initDeliveryMethodToggle();

            // Load existing sale info and populate form if available
            this.loadAndPopulateSaleInfo();

            this.checkoutButton = this.form.querySelector('.btn-checkout');
            this.confirmButton = this.form.querySelector('#confirm-contract-btn');
            this.initializePaymentHandler(this.getActivePaymentMethod());

            // Handle cancel button behaviour: on checkout-credix page, redirect to cart instead of just closing popup
            const cancelBtn = this.form.querySelector('.btn-cancel');
            if (cancelBtn) {
                cancelBtn.onclick = (event) => {
                    event.preventDefault();
                    const isCheckoutCredixPage = !!document.querySelector('checkout-creditcard');
                    if (isCheckoutCredixPage) {
                        window.location.href = `${window.Shopify.routes.root}cart`;
                    } else {
                        popupClose('popup_contract_information');
                    }
                };
            }

            if (this.confirmButton && 'MutationObserver' in window) {
                this.paymentMethodObserver = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'data-payment-method') {
                            this.initializePaymentHandler(this.getActivePaymentMethod());
                        }
                    });
                });

                this.paymentMethodObserver.observe(this.confirmButton, {
                    attributes: true,
                    attributeFilter: ['data-payment-method']
                });
            }
        }

        async loadAndPopulateSaleInfo() {
            const customerId = window.meta?.page?.customerId;
            if (!customerId) return;

            try {
                const saleInfoResult = await this.getSaleInfo(customerId);
                if (saleInfoResult.success && saleInfoResult.exists && saleInfoResult.data) {
                    this.populateFormFromSaleInfo(saleInfoResult.data);
                }
            } catch (error) {
                console.error('Error loading sale info:', error);
            }
        }

        setCookie(name, value, days) {
            let expires = '';
            if (days) {
                let date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + encodeURIComponent(value || "") + expires + "; path=/";
        }

        populateFormFromSaleInfo(saleInfo, editContract = false) {
            if (!saleInfo || !this.form) return;

            // Contract Holder Information
            const holderNameInput = this.form.querySelector('#holder-name');
            if (holderNameInput && saleInfo.contractHolderFullName) {
                holderNameInput.value = saleInfo.contractHolderFullName;
            }

            // Electronic holder name (for electronic confirmation)
            const electronicHolderHidden = this.form.querySelector('#electronic-holder-name');
            if (electronicHolderHidden && saleInfo.electronicHolderFullName) {
                electronicHolderHidden.value = saleInfo.electronicHolderFullName;
            }

            const holderAddressInput = this.form.querySelector('#holder-address');
            if (holderAddressInput && saleInfo.contractHolderAddress) {
                holderAddressInput.value = saleInfo.contractHolderAddress;
            }

            const holderPhoneInput = this.form.querySelector('#holder-phone');
            if (holderPhoneInput && saleInfo.contractHolderPhone) {
                holderPhoneInput.value = saleInfo.contractHolderPhone;
            }

            const holderEmailInput = this.form.querySelector('#holder-email');
            if (holderEmailInput && saleInfo.contractHolderEmail) {
                holderEmailInput.value = saleInfo.contractHolderEmail;
            }

            // Delivery method - only update radio when editContract is true
            if (editContract && saleInfo.contractDeliveryMethod) {
                const deliveryMethod = saleInfo.contractDeliveryMethod === 'paper' ? 'paper' : 'electronic';
                const deliveryRadio = this.form.querySelector(`input[name="contract_delivery_method"][value="${deliveryMethod}"]`);
                if (deliveryRadio) {
                    deliveryRadio.checked = true;
                    // Update UI without firing change handler (to avoid opening electronic popup on initial load)
                    this.toggleDeliveryFields();
                }
            } else {
                const deliveryRadio = this.form.querySelector(`input[name="contract_delivery_method"][value="paper"]`);
                if (deliveryRadio) {
                    deliveryRadio.checked = true;
                    // Update UI without firing change handler (to avoid opening electronic popup on initial load)
                    this.toggleDeliveryFields();
                }
            }

            // Additional emails
            const deliveryEmailInput = this.form.querySelector('#delivery-email');
            if (deliveryEmailInput && saleInfo.additionalEmails) {
                deliveryEmailInput.value = saleInfo.additionalEmails;
            }

            // Address ID
            if (saleInfo.addressId) {
                const defaultAddressInput = this.form.querySelector('#default_address');
                if (defaultAddressInput) {
                    defaultAddressInput.value = saleInfo.addressId;
                }

                // Try to find and update the address display
                // Note: We may need to fetch the address details if not already available
                // For now, we'll just update the hidden input
            }

            // Holder Address Info (full address object)
            const holderAddressInfoInput = this.form.querySelector('#holder_address_info');

            if (saleInfo.holderAddressInfo) {
                if (holderAddressInfoInput) {
                    // If holderAddressInfo is an object, stringify it; if it's already a string, use it directly
                    const addressValue = typeof saleInfo.holderAddressInfo === 'string'
                        ? saleInfo.holderAddressInfo
                        : JSON.stringify(saleInfo.holderAddressInfo);
                    holderAddressInfoInput.value = addressValue;

                    // Also update the address display if address object is available
                    if (typeof saleInfo.holderAddressInfo === 'object' && saleInfo.holderAddressInfo) {
                        this.updateDefaultAddressDisplay(saleInfo.holderAddressInfo);
                    } else if (typeof saleInfo.holderAddressInfo === 'string') {
                        try {
                            const parsedAddress = JSON.parse(saleInfo.holderAddressInfo);
                            this.updateDefaultAddressDisplay(parsedAddress);
                        } catch (err) {
                            console.warn('Error parsing holderAddressInfo:', err);
                        }
                    }
                }
            }

            // Sales Representative Information
            const receiveContractCheckbox = this.form.querySelector('#is-receiving-contract');
            if (receiveContractCheckbox) {
                receiveContractCheckbox.checked = true;
            }

            // Representative fields
            const repNameInput = this.form.querySelector('#rep-name');
            if (repNameInput && saleInfo.saleName) {
                repNameInput.value = saleInfo.saleName;
            }

            const repDepartmentInput = this.form.querySelector('#rep-department');
            if (repDepartmentInput && saleInfo.saleDepartment) {
                repDepartmentInput.value = saleInfo.saleDepartment;
            }

            const repPhoneInput = this.form.querySelector('#rep-phone');
            if (repPhoneInput && saleInfo.salePhoneNumber) {
                repPhoneInput.value = saleInfo.salePhoneNumber;
            }

            const repEmailInput = this.form.querySelector('#rep-email');
            if (repEmailInput && saleInfo.saleEmail) {
                repEmailInput.value = saleInfo.saleEmail;
            }

        }

        initDeliveryMethodToggle() {
            const deliveryMethodRadios = this.form.querySelectorAll('input[name="contract_delivery_method"]');
            const deliveryEmailField = this.form.querySelector('#delivery-email').closest('.form-field');
            const customerDefaultAddressField = this.form.querySelector('.customer_default_address');

            if (!deliveryMethodRadios.length || !deliveryEmailField || !customerDefaultAddressField) {
                return;
            }

            // Bind method
            this.toggleDeliveryFields = this.toggleDeliveryFields.bind(this);

            // Add event listeners to all radio buttons
            deliveryMethodRadios.forEach(radio => {
                radio.addEventListener('change', (event) => {
                    const target = event.target;
                    // Intercept change to electronic: require confirmation before actually switching
                    if (target && target.name === 'contract_delivery_method' && target.value === 'electronic' && target.checked) {
                        // Revert selection back to paper until user confirms
                        const paperRadio = this.form.querySelector('input[name="contract_delivery_method"][value="paper"]');
                        if (paperRadio) {
                            target.checked = false;
                            paperRadio.checked = true;
                        }
                        // Keep UI in sync with current (paper) selection
                        this.toggleDeliveryFields();
                        // Open confirmation popup
                        popupOpen('popup_electronic_confirmation');
                        return;
                    }

                    // Normal behaviour for other changes
                    this.toggleDeliveryFields();
                });
            });

            // Set initial state based on checked radio
            this.toggleDeliveryFields();
        }

        toggleDeliveryFields() {
            const selectedMethod = this.form.querySelector('input[name="contract_delivery_method"]:checked');
            const deliveryEmailField = this.form.querySelector('#delivery-email')?.closest('.form-field');
            const customerDefaultAddressField = this.form.querySelector('.customer_default_address');
            const changeAddressBtn = this.form.querySelector('#change-default-address');
            const addNewAddressBtn = this.form.querySelector('#add-new-address');
            const addressContentInput = this.form.querySelector('#holder_address_info');

            if (!selectedMethod || !deliveryEmailField || !customerDefaultAddressField) {
                return;
            }

            const isElectronic = selectedMethod.value === 'electronic';
            const deliveryMethod = selectedMethod.value;

            // Update data-delivery-method attribute on confirm-contract-btn and confirm-contract-electronic-btn
            const confirmContractBtn = document.querySelector('#confirm-contract-btn');
            const confirmElectronicBtn = document.querySelector('#confirm-contract-electronic-btn');
            if (confirmContractBtn) {
                confirmContractBtn.setAttribute('data-delivery-method', deliveryMethod);
            }
            if (confirmElectronicBtn) {
                confirmElectronicBtn.setAttribute('data-delivery-method', deliveryMethod);
            }

            if (isElectronic) {
                // Show email field, hide address field
                deliveryEmailField.style.display = '';
                customerDefaultAddressField.style.display = 'none';

                // Hide add new address button
                if (addNewAddressBtn) {
                    addNewAddressBtn.style.display = 'none';
                }

                // Make email required
                const emailInput = this.form.querySelector('#delivery-email');
                if (emailInput) {
                    emailInput.setAttribute('required', 'required');
                    emailInput.setCustomValidity('');
                }
            } else {
                // Show address field, hide email field
                deliveryEmailField.style.display = 'none';
                customerDefaultAddressField.style.display = '';

                // Remove required from email
                const emailInput = this.form.querySelector('#delivery-email');
                if (emailInput) {
                    emailInput.removeAttribute('required');
                    emailInput.setCustomValidity('');
                    //emailInput.value = '';
                }

                // Check if address exists (handle null, empty string, and invalid JSON)
                let hasAddress = false;
                if (addressContentInput && addressContentInput.value) {
                    const addressValue = addressContentInput.value.trim();
                    if (addressValue !== '' && addressValue !== 'null' && addressValue !== 'undefined') {
                        try {
                            // Try to parse as JSON to validate
                            const parsedAddress = JSON.parse(addressValue);
                            // Check if parsed address is a valid object (not null)
                            hasAddress = parsedAddress && typeof parsedAddress === 'object' && parsedAddress !== null;
                        } catch (err) {
                            // If parsing fails, consider it invalid
                            hasAddress = false;
                        }
                    }
                }

                if (hasAddress) {
                    // Show change button, hide add new address button
                    if (changeAddressBtn) {
                        changeAddressBtn.style.display = 'block';
                    }
                    if (addNewAddressBtn) {
                        addNewAddressBtn.style.display = 'none';
                    }
                } else {
                    // Hide change button, show add new address button
                    if (changeAddressBtn) {
                        changeAddressBtn.style.display = 'block';
                    }
                    if (addNewAddressBtn) {
                        addNewAddressBtn.style.display = 'none';
                    }
                }
            }
        }

        getActivePaymentMethod() {
            if (!this.form) return 'gmo';
            const button = this.form.querySelector('#confirm-contract-btn');
            if (button) {
                const attr = button.getAttribute('data-payment-method');
                if (attr) {
                    return attr;
                }
            }

            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('payment') || 'gmo';
        }

        initializePaymentHandler(method) {
            if (!this.form) return;

            if (this.currentPaymentMethod === method && this.checkoutButton && typeof this.checkoutButton.onclick === 'function') {
                return;
            }

            this.currentPaymentMethod = method;

            // Update confirm-contract-btn text based on payment method
            const confirmContractBtn = this.form.querySelector('#confirm-contract-btn');
            if (confirmContractBtn) {
                // If payment method is eth, credix, credix_type, credix_first_purchase, or web3, restore text from data-checkout-label
                if (['eth', 'credix', 'credix_type', 'credix_first_purchase', 'web3', 'manual-bank'].includes(method)) {
                    if (confirmContractBtn.hasAttribute('data-checkout-label')) {
                        const checkoutLabel = confirmContractBtn.getAttribute('data-checkout-label');
                        if (checkoutLabel) {
                            confirmContractBtn.textContent = checkoutLabel;
                        }
                    }
                }
            }

            switch (method) {
                case 'eth':
                    this.initEth();
                    this.initEthJpCheckoutSale();
                    break;
                case 'credix':
                    this.initCredix();
                    break;
                case 'credix_type':
                    this.initCredixType();
                    break;
                case 'credix_first_purchase':
                    this.initCredixFirstPurchase();
                    break;
                case 'profile_update':
                    this.initProfileUpdate();
                    break;
                case 'web3':
                    this.initWeb3();
                    break;
                case 'manual-bank':
                    this.initManualBank();
                    break;
                case 'edit_contract':
                    this.initEditContract();
                    this.initEditConfirmContract();
                    break;
                default:
                    this.initGmo();
            }
        }

        validateElectronicDeliveryEmail() {
            if (!this.form) return true;

            const selectedMethod = this.form.querySelector('input[name="contract_delivery_method"]:checked');
            if (!selectedMethod || selectedMethod.value !== 'electronic') {
                return true;
            }

            const emailInput = this.form.querySelector('#delivery-email');
            if (!emailInput) {
                return true;
            }

            emailInput.setAttribute('required', 'required');
            emailInput.setCustomValidity('');

            let value = (emailInput.value || '').trim();
            if (!value) {
                const message = theme.strings.contract.msg_delivery_email;
                emailInput.setCustomValidity(message);
                emailInput.reportValidity();
                emailInput.focus();
                return false;
            }

            // Normalize delimiters (support comma, semicolon, full-width characters, new lines)
            const normalizedValue = value
                .replace(/[；，;]/g, ',')    // replace full-width comma/semicolon with comma
                .replace(/[\r\n]+/g, ',')   // replace new lines with comma
                .replace(/\s*,\s*/g, ',');  // remove spaces around commas

            // Basic email regex (same as HTML5 email type)
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
            const zeroWidthCharsRegex = /[\u200B-\u200D\uFEFF]/g;
            const emails = normalizedValue
                .split(',')
                .map(email => email.replace(zeroWidthCharsRegex, '').trim())
                .filter(email => email !== '');

            if (emails.length === 0) {
                const message = theme.strings.contract.msg_delivery_email;
                emailInput.setCustomValidity(message);
                emailInput.reportValidity();
                emailInput.focus();
                return false;
            }

            // Validate each email
            const invalidEmails = emails.filter(email => !emailRegex.test(email));
            if (invalidEmails.length > 0) {
                const message = `Invalid email${invalidEmails.length > 1 ? 's' : ''}: ${invalidEmails.join(', ')}`;
                emailInput.setCustomValidity(message);
                emailInput.reportValidity();
                emailInput.focus();
                return false;
            }

            // Persist normalized, trimmed list back to the field for future edits
            emailInput.value = emails.join(', ');
            emailInput.setCustomValidity('');
            return true;
        }

        initAccordion() {
            const sectionHeaders = this.querySelectorAll('.section-header');

            sectionHeaders.forEach(header => {
                const sectionContent = header.nextElementSibling;

                if (!sectionContent || !sectionContent.classList.contains('section-content')) {
                    return;
                }

                // Set initial state - all sections expanded by default
                header.classList.add('expanded');
                sectionContent.classList.remove('collapsed');

                // Handle click on header
                header.addEventListener('click', () => {
                    this.toggleSection(header, sectionContent);
                });
            });
        }

        toggleSection(header, content) {
            const isCollapsed = header.classList.contains('collapsed');

            if (isCollapsed) {
                // Expand
                header.classList.remove('collapsed');
                header.classList.add('expanded');
                content.classList.remove('collapsed');
            } else {
                // Collapse
                header.classList.remove('expanded');
                header.classList.add('collapsed');
                content.classList.add('collapsed');
            }
        }

        handleSubmit(e) {
            e.preventDefault();
            // Form submission is now handled by initGmo
            // This prevents default form submission
        }

        handleNoElectronicClick(event) {
            if (!event || event.target?.id !== 'btn_no_electronic_confirmation') {
                return;
            }
            const paperRadio = this.form?.querySelector('input[name="contract_delivery_method"][value="paper"]');
            if (paperRadio) {
                paperRadio.checked = true;
                paperRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
            if (this.checkoutButton) {
                this.checkoutButton.removeAttribute('disabled');
            }
            const loadingBg = document.querySelector('.loading_bg');
            if (loadingBg) {
                loadingBg.style.display = 'none';
            }
            popupClose('popup_electronic_confirmation');
        }

        async getSaleInfo(customerId) {
            try {
                if (!customerId) {
                    return { success: false, exists: false };
                }

                const saleInfoApiUrl = `${window.shopify_server_url}/sale/user-sale-info?customerId=${customerId}`;

                const response = await fetch(saleInfoApiUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Origin': window.location.origin,
                        'Accept-Language': Shopify.locale || 'ja',
                        'X-Sig': window.sz_config?.shopify_server_key,
                        'X-Epoch': window.sz_config?.timestamp
                    }
                });

                const result = await response.json();

                // Check if response has data (API returns object directly with id, ssoId, customerId, etc.)
                if (response.ok && result && (result.id || result.customerId || result.ssoId)) {
                    // Sale info exists
                    return { success: true, exists: true, data: result };
                } else if (response.status === 404 || !result || (!result.id && !result.customerId && !result.ssoId)) {
                    // No sale info found
                    return { success: true, exists: false };
                } else {
                    console.warn('Failed to get sale info:', result);
                    return { success: false, exists: false, error: result };
                }
            } catch (error) {
                console.error('Error getting sale info:', error);
                return { success: false, exists: false, error: error.message };
            }
        }

        async saveSaleInfo(saleContract, authJson) {
            try {
                const customerId = window.meta?.page?.customerId;
                if (!customerId) {
                    console.warn('Customer ID not found, skipping save sale info');
                    return { success: false };
                }

                // Get ssoId from authJson
                const ssoId = authJson?.user?.id || null;
                if (!ssoId) {
                    console.warn('SSO ID not found, skipping save sale info');
                    return { success: false };
                }

                // Check if sale info already exists
                const existingSaleInfo = await this.getSaleInfo(customerId);
                const isUpdate = existingSaleInfo.success && existingSaleInfo.exists;

                // Get shop domain
                const shop = window.Shopify?.shop || window.location.hostname || '';

                // Map saleContract to API format
                const saleInfoData = {
                    ssoId: parseInt(ssoId),
                    customerId: parseInt(customerId),
                    email: window.customerEmail || saleContract.email || '',
                    shop: shop,
                    ip: window.customerIp || null,
                    // Always send boolean true/false to API
                    isReceivingContract: saleContract.is_receiving_contract === 1 || saleContract.is_receiving_contract === true,
                    contractHolderFullName: saleContract.contract_holder_full_name || '',
                    electronicHolderFullName: '',
                    contractHolderEmail: saleContract.contract_holder_email || '',
                    contractHolderPhone: saleContract.contract_holder_phone || '',
                    contractHolderAddress: saleContract.contract_holder_address || '',
                    additionalEmails: saleContract.additional_emails || '',
                    addressId: saleContract.address_id || null,
                    holderAddressInfo: saleContract.holder_address_info || null,
                    contractDeliveryMethod: saleContract.contract_delivery_method,
                    saleName: saleContract.sale_name || '',
                    saleDepartment: saleContract.sale_department || '',
                    salePhoneNumber: saleContract.sale_phone_number || '',
                    saleEmail: saleContract.sale_email || ''
                };

                // Add saleName if exists
                if (saleContract.sale_name) {
                    saleInfoData.saleName = saleContract.sale_name;
                }

                // Determine API URL
                const saleInfoApiUrl = `${window.shopify_server_url}/sale/user-sale-info`;

                // Use PUT if exists, POST if not
                const method = isUpdate ? 'PUT' : 'POST';
                const url = isUpdate ? `${saleInfoApiUrl}?customerId=${customerId}` : saleInfoApiUrl;

                const response = await fetch(url, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                        'Origin': window.location.origin,
                        'Accept-Language': Shopify.locale || 'ja',
                        'X-Sig': window.sz_config?.shopify_server_key,
                        'X-Epoch': window.sz_config?.timestamp
                    },
                    body: JSON.stringify(saleInfoData)
                });

                const result = await response.json();

                if (response.ok && !result.errors) {
                    // Mark that the contract has been confirmed & saved this session, so
                    // the checkout page's contract gate stops forcing the popup on every
                    // btn-submit / btn-update click (prevents the confirm -> popup loop).
                    try { sessionStorage.setItem('contract_confirmed', '1'); } catch (e) {}
                    return { success: true, data: result, isUpdate: isUpdate };
                } else {
                    console.warn(`Failed to ${isUpdate ? 'update' : 'save'} sale info:`, result);
                    return { success: false, error: result };
                }
            } catch (error) {
                console.error('Error saving sale info:', error);
                return { success: false, error: error.message };
            }
        }

        buildSaleContract(skipReceivingContractValidation = false) {
            if (!this.form) return null;
            if (!this.validateElectronicDeliveryEmail()) {
                return null;
            }

            const formData = new FormData(this.form);
            const data = {};
            for (const [key, value] of formData.entries()) {
                data[key] = value;
            }

            const receiveContractCheckbox = this.form.querySelector('#is-receiving-contract');
            const isReceivingContractChecked = receiveContractCheckbox?.checked || false;

            // Skip validation for is-receiving-contract if skipReceivingContractValidation is true
            if (!skipReceivingContractValidation) {
                if (!isReceivingContractChecked) {
                    if (receiveContractCheckbox) {
                        const message = theme.strings.contract.msg_required_receive_contract;
                        receiveContractCheckbox.setCustomValidity(message);
                        receiveContractCheckbox.reportValidity();
                        receiveContractCheckbox.focus();
                    }
                    return null;
                } else if (receiveContractCheckbox) {
                    receiveContractCheckbox.setCustomValidity('');
                }
            }

            // Validate paper delivery method requires address
            const deliveryMethod = data.contract_delivery_method || 'electronic';
            if (deliveryMethod === 'paper' || deliveryMethod === 'electronic') {
                const addressContentInput = this.form.querySelector('#holder_address_info');
                const holderAddressInput = this.form.querySelector('#holder-address');
                let hasValidAddress = false;

                if (addressContentInput && addressContentInput.value) {
                    const addressValue = addressContentInput.value.trim();
                    if (addressValue !== '' && addressValue !== 'null' && addressValue !== 'undefined') {
                        try {
                            // Try to parse as JSON to validate
                            const parsedAddress = JSON.parse(addressValue);
                            // Check if parsed address is a valid object (not null)
                            hasValidAddress = parsedAddress && typeof parsedAddress === 'object' && parsedAddress !== null;
                        } catch (err) {
                            // If parsing fails, consider it invalid
                            hasValidAddress = false;
                        }
                    }
                }

                // Also validate holder-address input (readonly display field)
                if (holderAddressInput) {
                    const holderAddressValue = holderAddressInput.value.trim();
                    if (!holderAddressValue || holderAddressValue === '') {
                        hasValidAddress = false;
                    }
                }

                if (!hasValidAddress) {
                    // Show error message
                    const customerDefaultAddressField = this.form.querySelector('.form-field-address-wrapper');
                    if (customerDefaultAddressField) {
                        let errorMsg = customerDefaultAddressField.querySelector('.address-error-message');
                        if (!errorMsg) {
                            errorMsg = document.createElement('div');
                            errorMsg.className = 'address-error-message';
                            errorMsg.style.color = 'red';
                            errorMsg.style.marginTop = '8px';
                            errorMsg.textContent = theme.strings.contract.msg_recipient_address;
                            customerDefaultAddressField.appendChild(errorMsg);
                        } else {
                            errorMsg.style.display = 'block';
                        }
                    }
                    return null;
                } else {
                    // Hide error message if exists
                    const errorMsg = this.form.querySelector('.address-error-message');
                    if (errorMsg) {
                        errorMsg.style.display = 'none';
                    }
                }
            }

            // Get customer default address for recipient info
            const defaultAddressId = data.default_address;
            let recipientAddress = null;
            let holderAddressInfo = null;

            // Try to get address from hidden input first
            const addressContentInput = this.form.querySelector('#holder_address_info');
            if (addressContentInput && addressContentInput.value) {
                try {
                    recipientAddress = JSON.parse(addressContentInput.value);
                    // Store the full address info as holderAddressInfo
                    holderAddressInfo = recipientAddress;
                } catch (err) {
                    console.warn('Error parsing address content from hidden input:', err);
                }
            }

            // Fallback: Try to get address from customer object if available
            if (!recipientAddress && window.customer && window.customer.default_address) {
                recipientAddress = window.customer.default_address;
                // Also set holderAddressInfo from customer default address if not already set
                if (!holderAddressInfo) {
                    holderAddressInfo = window.customer.default_address;
                }
            }

            // Helper function to safely get address field
            const getAddressField = (field, fallback = '') => {
                if (!recipientAddress) return fallback;
                return recipientAddress[field] || fallback;
            };

            // Get confirmed electronic holder name from hidden input (set when user confirms in popup)
            const electronicHolderInput = this.form.querySelector('#electronic-holder-name');
            const electronicHolderName = (electronicHolderInput?.value || '').trim();

            const saleContract = {
                // Recipient information (from customer default address)
                email: window.customerEmail || getAddressField('email', ''),
                last_name: getAddressField('last_name', ''),
                first_name: getAddressField('first_name', ''),
                phone: getAddressField('phone', ''),
                country: getAddressField('country', ''),
                province: getAddressField('province', ''),
                postal_zip_code: getAddressField('zip', ''),
                city: getAddressField('city', ''),
                address1: getAddressField('address1', ''),
                address2: getAddressField('address2', ''),
                ip: window.customerIp || null,

                // Contract receiving flag - get directly from checkbox
                is_receiving_contract: isReceivingContractChecked ? 1 : 0,
                language: Shopify.locale,

                // Contract holder information
                contract_holder_full_name: data.contract_holder_full_name || '',
                electronic_holder_full_name: data.electronic_holder_full_name || '',
                contract_holder_email: data.contract_holder_email || '',
                contract_holder_phone: data.contract_holder_phone || '',
                contract_holder_address: data.contract_holder_address || '',

                // Additional emails (only for electronic delivery)
                additional_emails: data.additional_emails || '',

                // Address ID
                address_id: defaultAddressId ? parseInt(defaultAddressId) : null,

                // Holder address info (full address object from holder_address_info)
                holder_address_info: holderAddressInfo,

                // Sales representative information
                contract_delivery_method: deliveryMethod,
                
                // Agreement time - only for electronic delivery
                ...(deliveryMethod === 'electronic' ? { agreement_time: new Date().toISOString() } : {}),
                sale_department: data.sale_department || '',
                sale_phone_number: data.sale_phone_number || '',
                sale_email: data.sale_email || '',
                sale_name: data.sale_name || '',
            };


            return saleContract;
        }

        initManualBank() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const self = this;
            const loading_bg = document.querySelector('.loading_bg');
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            checkoutBtn.onclick = function(e) {
                e.preventDefault();
                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                // Step1 (bank name) → contract → create order with saleContract
                if (typeof _manualBankState !== 'undefined' && _manualBankState.awaitingContractAfterStep1) {
                    const saleContract = self.buildSaleContract();
                    if (!saleContract) {
                        return;
                    }

                    checkoutBtn.setAttribute('disabled', 'true');
                    if (loading_bg) loading_bg.style.display = 'block';

                    var authJson = null;
                    if (authToken) {
                        try {
                            authJson = JSON.parse(authToken);
                        } catch (err) {
                            console.error('initManualBank auth parse:', err);
                        }
                    }

                    self.saveSaleInfo(saleContract, authJson)
                        .then(() => {
                            if (typeof popupClose === 'function') {
                                // Closing contract popup here is part of the manual-bank+contract flow.
                                // Skip auto-reopen of manual-bank step1; we need to keep the loading state
                                // until order/create finishes inside manual-bank-transfer.js.
                                if (typeof window.popupClose === 'function') {
                                    window.popupClose.__skipManualBankReopen = true;
                                }
                                popupClose('popup_contract_information');
                            }
                            _manualBankState.awaitingContractAfterStep1 = false;
                            if (typeof window.submitManualBankStep1WithContract === 'function') {
                                window.submitManualBankStep1WithContract(customerId, saleContract);
                            }
                        })
                        .catch((err) => {
                            console.error('initManualBank saveSaleInfo:', err);
                            if (loading_bg) loading_bg.style.display = 'none';
                            checkoutBtn.removeAttribute('disabled');
                        })
                        .finally(() => {
                            // Always re-enable after save attempt so reopening the popup is usable
                            checkoutBtn.removeAttribute('disabled');
                        });

                    return;
                }

                // Fallback: contract opened first → go to manual bank step1
                popupClose('popup_contract_information');
                if (typeof openManualBankStep1 === 'function') {
                    openManualBankStep1(customerId, checkoutBtn);
                }
            };
        }

        async initGmo() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            const modalcart = document.getElementById("popup-success");
            const modalCartError = document.getElementById("popup-error");
            const apiUrl = `${window.GMO_APP_URL}api/order/create`;
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            const self = this; // Save reference to class instance
            checkoutBtn.onclick = function(e){
                e.preventDefault();
                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }
                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    if (loading_bg) loading_bg.style.display = "none";
                    checkoutBtn.removeAttribute('disabled');
                    return;
                }
                checkoutBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                purchaseCheck().then(purchase => {
                    loading_bg.style.display = "none";
                    if (purchase && !purchase.success) {
                        // Map error code to user-friendly message
                        const errorMessage = window.purchase_message && window.purchase_message[purchase.message]
                            ? window.purchase_message[purchase.message]
                            : purchase.message;
                        showToast(errorMessage, 'error', 6000, {
                            limit_value_jpy: purchase.limit_value_jpy,
                            limit_duration_days: purchase.limit_duration_days
                        });
                        checkoutBtn.removeAttribute('disabled');
                        return;
                    }

                    inventoryCheck().then(inventory => {
                        loading_bg.style.display = "none";
                        if (inventory && inventory.agePriceRestriction && inventory.agePriceRestriction.blocked) {
                            const reason = inventory.agePriceRestriction.reason || 'age_price_restricted';
                            const ageRestrictionMessage = (window.purchase_message && window.purchase_message[reason])
                                ? window.purchase_message[reason]
                                : reason;
                            showToast(ageRestrictionMessage, 'error', 6000);
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }
                        if (inventory && inventory.purchaseTierRestriction && inventory.purchaseTierRestriction.blocked) {
                            const restriction = inventory.purchaseTierRestriction;
                            const tierRestrictionMessage = getPurchaseTierRestrictionMessage(restriction);
                            showToast(tierRestrictionMessage, 'error', 6000);
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }
                        if (inventory && inventory.outOfStockItems && inventory.outOfStockItems.length > 0) {

                            const productPopup = document.querySelector('#popup-product-message');
                            const itemNames = inventory.outOfStockItems.map(item =>
                                `${item.name} (SKU: ${item.sku})`
                            ).join(', ');
                            //productPopup.querySelector('.product_outofstock_name').innerHTML = itemNames;
                            popupOpen('popup-product-message');
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }

                        if (inventory && inventory.activeSubs && inventory.activeSubs.length > 0) {
                            popupOpen('popup-active-subs');
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }

                        if (checkoutBtn.classList.contains('customer-no-card')) {
                            getCardInfo(customerId)
                                .then(isCard => {
                                    if (isCard) {
                                        if (authToken) {
                                            var authJson = JSON.parse(authToken);
                                            if(authJson.access_token) {
                                                getUserInfo(authJson.access_token)
                                                    .then(resData => {
                                                        if (resData){
                                                            if (resData.verify_phone_status){
                                                                if (resData.is_agree_credix_term) {
                                                                    loading_bg.style.display = "block";
                                                                    getSection('cart-data')
                                                                        .then((data) => {
                                                                            const response = JSON.parse(data);
                                                                            if (response.items) {
                                                                                var itemsCart = response.items.map(function(item) {
                                                                                    return {
                                                                                        item_id: item.id,
                                                                                        item_name: item.title,
                                                                                        avatar_id: item.id,
                                                                                        avatar_sku: item.sku,
                                                                                        item_brand: item.avatar_type || '',
                                                                                        price: item.price / 100,
                                                                                        quantity: item.quantity
                                                                                    };
                                                                                });
                                                                                if (authToken) {
                                                                                    var authJson = JSON.parse(authToken);
                                                                                }
                                                                                trackCheckOut("GMO", authJson, itemsCart);
                                                                                const saleContract = self.buildSaleContract();
                                                                                if (!saleContract) {
                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                    checkoutBtn.removeAttribute('disabled');
                                                                                    return;
                                                                                }

                                                                                const continueGmoOrder = () => {
                                                                                    self.saveSaleInfo(saleContract, authJson).then(() => {
                                                                                        const requestBody = { customerId, saleContract, items: response.items };
                                                                                        const affid = getCookie('affid');
                                                                                        const oid = getCookie('oid');
                                                                                        if (affid && oid) {
                                                                                            requestBody.affInfo = {
                                                                                                affId: affid,
                                                                                                oid: oid
                                                                                            };
                                                                                        }
                                                                                        fetch(apiUrl, {
                                                                                            method: 'POST',
                                                                                            body: JSON.stringify(requestBody),
                                                                                            headers: {
                                                                                                'Content-Type': 'application/json',
                                                                                                'Accept-Language': Shopify.locale,
                                                                                                'X-Sig': window.sz_config.gmo_key,
                                                                                                'X-Epoch': window.sz_config.timestamp
                                                                                            }
                                                                                        })
                                                                                            .then((response) => response.json())
                                                                                            .then((response) => {
                                                                                                if (!response.errors) {
                                                                                                    const account = response.account;
                                                                                                    const formattedAmount = new Intl.NumberFormat('ja-JP', {
                                                                                                        style: 'currency',
                                                                                                        currency: 'JPY',
                                                                                                    }).format(account.amountTransfer);
                                                                                                    if (modalCartError) modalCartError.style.display = "none";
                                                                                                    if (modalcart) modalcart.style.display = "block";
                                                                                                    document.querySelector('#gmo_summary_tax').innerHTML = Shopify.formatMoney(account.tax*100, "{{amount_no_decimals}}")  + ' ' + account.currency;
                                                                                                    document.querySelector('#gmo_summary_orderamount').innerHTML =  Shopify.formatMoney(account.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + account.currency;
                                                                                                    document.querySelector('#gmo_summary_totalpayment').innerHTML =  Shopify.formatMoney((account.tax + account.totalPrice)*100, "{{amount_no_decimals}}")  + ' ' + account.currency;
                                                                                                    document.querySelector('#gmo_bank_code').innerHTML = account.bankCode;
                                                                                                    document.querySelector('#gmo_bank_name').innerHTML = account.bankName;
                                                                                                    document.querySelector('#gmo_branch_code').innerHTML = account.branchCode;
                                                                                                    document.querySelector('#gmo_account_number').innerHTML = account.accountNumber;
                                                                                                    document.querySelector('#gmo_branch_name_kana').innerHTML = account.branchNameKana;
                                                                                                    document.querySelector('#gmo_holdername_kana').innerHTML = account.holderNameKana;
                                                                                                    document.querySelector('#gmo_amount').innerHTML = formattedAmount;
                                                                                                    document.querySelector('#gmo_note').innerHTML = account.note;
                                                                                                    if (typeof clearGmoCart === 'function') {
                                                                                                        clearGmoCart();
                                                                                                    } else {
                                                                                                        // Fallback: clear cart directly
                                                                                                        fetch(window.Shopify.routes.root + 'cart/clear.js', {
                                                                                                            method: 'POST',
                                                                                                        })
                                                                                                            .then((response) => response.json())
                                                                                                            .then((response) => {
                                                                                                                if(response.item_count === 0) {
                                                                                                                    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    self.checkGmoOrderStatus(account.note);
                                                                                                    let gmoCancelButton = document.querySelector('#confirm-cancel-gmoorder-btn');
                                                                                                    if (gmoCancelButton) {
                                                                                                        gmoCancelButton.setAttribute('data-order-id', account.orderId);
                                                                                                        // Attach cancel handler if not already attached
                                                                                                        if (!gmoCancelButton.hasAttribute('data-cancel-handler-attached')) {
                                                                                                            gmoCancelButton.setAttribute('data-cancel-handler-attached', 'true');
                                                                                                            gmoCancelButton.addEventListener('click', function() {
                                                                                                                const cancelOrderId = this.getAttribute('data-order-id');
                                                                                                                if (cancelOrderId) {
                                                                                                                    self.cancelGmoOrder(cancelOrderId);
                                                                                                                }
                                                                                                            });
                                                                                                        }
                                                                                                    }

                                                                                                    trackPurchaseSuccess(account.orderId, authJson, itemsCart);
                                                                                                    popupClose('popup_contract_information');
                                                                                                } else {
                                                                                                    let errorMessage = Object.values(response.errors)[0];
                                                                                                    let commonPopup = document.querySelector('#popup-common-message');
                                                                                                    let messageError;
                                                                                                    if (errorMessage === 'product.outstock') {
                                                                                                        let productPopup = document.querySelector('#popup-product-message');
                                                                                                        const errorDetail = Object.values(response.errors)[1] || '';
                                                                                                        //productPopup.querySelector('.product_outofstock_name').innerHTML = errorDetail;
                                                                                                        popupOpen('popup-product-message');
                                                                                                        trackPurchaseFail(errorDetail);
                                                                                                    } else {
                                                                                                        messageError = document.querySelector('.eth-checkout-btn').getAttribute(`data-${errorMessage}`);
                                                                                                        errorMessage = prepareCheckoutError(response, errorMessage, window.CHECKOUT_ERROR_MESSAGES.OUTSTOCK);
                                                                                                        popupOpen('popup-common-message');
                                                                                                        commonPopup.querySelector('h4').innerHTML = commonPopup.querySelector('h4').getAttribute('data-errorTitle');
                                                                                                        commonPopup.querySelector('p').innerHTML = messageError ? messageError : errorMessage;

                                                                                                        if (response.errors.hasPendingOrder) {
                                                                                                            commonPopup.querySelector('.btn-view').style.display = 'block';
                                                                                                        } else {
                                                                                                            commonPopup.querySelector('.btn-view').style.display = 'none';
                                                                                                        }
                                                                                                        trackPurchaseFail(messageError ? messageError : errorMessage);
                                                                                                    }

                                                                                                }
                                                                                                if (loading_bg) loading_bg.style.display = "none";
                                                                                                checkoutBtn.removeAttribute('disabled');
                                                                                                popupClose('popup_contract_information');
                                                                                            }).catch(console.error);
                                                                                    }).catch(console.error);
                                                                                };

                                                                                // if (saleContract.contract_delivery_method === 'electronic' && !saleContract.electronic_holder_full_name) {
                                                                                //     if (loading_bg) loading_bg.style.display = "none";
                                                                                //     self.pendingElectronicAction = () => {
                                                                                //         self.pendingElectronicAction = null;
                                                                                //         checkoutBtn.setAttribute('disabled', 'true');
                                                                                //         if (loading_bg) loading_bg.style.display = "block";
                                                                                //         continueGmoOrder();
                                                                                //     };
                                                                                //     popupOpen('popup_electronic_confirmation');
                                                                                //     return;
                                                                                // }

                                                                                continueGmoOrder();
                                                                            } else {
                                                                                if (loading_bg) loading_bg.style.display = "none";
                                                                                checkoutBtn.removeAttribute('disabled');
                                                                                popupClose('popup_contract_information');
                                                                            }
                                                                        }).catch(console.error);
                                                                } else {
                                                                    popupOpen('popup-common-term-condition');
                                                                    checkoutBtn.removeAttribute('disabled');
                                                                }
                                                            } else {
                                                                popupOpen('popup-common-verified-phone');
                                                                checkoutBtn.removeAttribute('disabled');
                                                            }
                                                        }
                                                    });
                                            }
                                        }

                                    } else {
                                        // No card yet: save sale info before showing secure payment popup
                                        const saleContractNoCard = self.buildSaleContract();
                                        if (!saleContractNoCard) {
                                            if (loading_bg) loading_bg.style.display = "none";
                                            checkoutBtn.removeAttribute('disabled');
                                            return;
                                        }

                                        let authJsonNoCard = null;
                                        if (authToken) {
                                            try {
                                                authJsonNoCard = JSON.parse(authToken);
                                            } catch (err) {
                                                console.error('Error parsing auth token (no-card GMO):', err);
                                            }
                                        }

                                        self.saveSaleInfo(saleContractNoCard, authJsonNoCard)
                                            .catch((error) => {
                                                console.error('Error saving sale info before secure payment (GMO):', error);
                                            })
                                            .finally(() => {
                                                popupOpen('popup-common-secure-payment');
                                                checkoutBtn.removeAttribute('disabled');
                                            });
                                        return;
                                    }
                                });
                        } else {

                            if (authToken) {
                                var authJson = JSON.parse(authToken);
                                if(authJson.access_token) {
                                    getUserInfo(authJson.access_token)
                                        .then(resData => {
                                            if (resData){
                                                if (resData.verify_phone_status){

                                                    loading_bg.style.display = "block";
                                                    getSection('cart-data')
                                                        .then((data) => {
                                                            const response = JSON.parse(data);
                                                            if (response.items) {
                                                                var itemsCart = response.items.map(function(item) {
                                                                    return {
                                                                        item_id: item.id,
                                                                        item_name: item.title,
                                                                        avatar_id: item.id,
                                                                        avatar_sku: item.sku,
                                                                        item_brand: item.avatar_type || '',
                                                                        price: item.price / 100,
                                                                        quantity: item.quantity
                                                                    };
                                                                });
                                                                if (authToken) {
                                                                    var authJson = JSON.parse(authToken);
                                                                }
                                                                trackCheckOut("GMO", authJson, itemsCart);
                                                                const saleContract = self.buildSaleContract();
                                                                if (!saleContract) {
                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                    checkoutBtn.removeAttribute('disabled');
                                                                    return;
                                                                }

                                                                const processGmoOrder = (skipElectronicConfirm = false) => {
                                                                    // if (saleContract.contract_delivery_method === 'electronic' && !saleContract.electronic_holder_full_name && !skipElectronicConfirm) {
                                                                    //     if (loading_bg) loading_bg.style.display = "none";
                                                                    //     self.pendingElectronicAction = () => {
                                                                    //         self.pendingElectronicAction = null;
                                                                    //         checkoutBtn.setAttribute('disabled', 'true');
                                                                    //         if (loading_bg) loading_bg.style.display = "block";
                                                                    //         processGmoOrder(true);
                                                                    //     };
                                                                    //     popupOpen('popup_electronic_confirmation');
                                                                    //     return;
                                                                    // }

                                                                    // Save sale info before creating order
                                                                    self.saveSaleInfo(saleContract, authJson).then(() => {
                                                                        const requestBody = { customerId, saleContract, items: response.items };
                                                                        const affid = getCookie('affid');
                                                                        const oid = getCookie('oid');
                                                                        if (affid && oid) {
                                                                            requestBody.affInfo = { affId: affid, oid: oid };
                                                                        }
                                                                        // Continue with order creation
                                                                        fetch(apiUrl, {
                                                                            method: 'POST',
                                                                            body: JSON.stringify(requestBody),
                                                                            headers: {
                                                                                'Content-Type': 'application/json',
                                                                                'Accept-Language': Shopify.locale,
                                                                                'X-Sig': window.sz_config.gmo_key,
                                                                                'X-Epoch': window.sz_config.timestamp
                                                                            }
                                                                        })
                                                                            .then((response) => response.json())
                                                                            .then((response) => {
                                                                                if (!response.errors) {
                                                                                    const account = response.account;
                                                                                    const formattedAmount = new Intl.NumberFormat('ja-JP', {
                                                                                        style: 'currency',
                                                                                        currency: 'JPY',
                                                                                    }).format(account.amountTransfer);
                                                                                    if (modalCartError) modalCartError.style.display = "none";
                                                                                    if (modalcart) modalcart.style.display = "block";
                                                                                    document.querySelector('#gmo_summary_tax').innerHTML = Shopify.formatMoney(account.tax*100, "{{amount_no_decimals}}")  + ' ' + account.currency;
                                                                                    document.querySelector('#gmo_summary_orderamount').innerHTML =  Shopify.formatMoney(account.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + account.currency;
                                                                                    document.querySelector('#gmo_summary_totalpayment').innerHTML =  Shopify.formatMoney((account.tax + account.totalPrice)*100, "{{amount_no_decimals}}")  + ' ' + account.currency;
                                                                                    document.querySelector('#gmo_bank_code').innerHTML = account.bankCode;
                                                                                    document.querySelector('#gmo_bank_name').innerHTML = account.bankName;
                                                                                    document.querySelector('#gmo_branch_code').innerHTML = account.branchCode;
                                                                                    document.querySelector('#gmo_account_number').innerHTML = account.accountNumber;
                                                                                    document.querySelector('#gmo_branch_name_kana').innerHTML = account.branchNameKana;
                                                                                    document.querySelector('#gmo_holdername_kana').innerHTML = account.holderNameKana;
                                                                                    document.querySelector('#gmo_amount').innerHTML = formattedAmount;
                                                                                    document.querySelector('#gmo_note').innerHTML = account.note;
                                                                                    if (typeof clearGmoCart === 'function') {
                                                                                        clearGmoCart();
                                                                                    } else {
                                                                                        // Fallback: clear cart directly
                                                                                        fetch(window.Shopify.routes.root + 'cart/clear.js', {
                                                                                            method: 'POST',
                                                                                        })
                                                                                            .then((response) => response.json())
                                                                                            .then((response) => {
                                                                                                if(response.item_count === 0) {
                                                                                                    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
                                                                                                }
                                                                                            });
                                                                                    }
                                                                                    self.checkGmoOrderStatus(account.note);
                                                                                    let gmoCancelButton = document.querySelector('#confirm-cancel-gmoorder-btn');
                                                                                    if (gmoCancelButton) {
                                                                                        gmoCancelButton.setAttribute('data-order-id', account.orderId);
                                                                                        // Attach cancel handler if not already attached
                                                                                        if (!gmoCancelButton.hasAttribute('data-cancel-handler-attached')) {
                                                                                            gmoCancelButton.setAttribute('data-cancel-handler-attached', 'true');
                                                                                            gmoCancelButton.addEventListener('click', function() {
                                                                                                const cancelOrderId = this.getAttribute('data-order-id');
                                                                                                if (cancelOrderId) {
                                                                                                    self.cancelGmoOrder(cancelOrderId);
                                                                                                }
                                                                                            });
                                                                                        }
                                                                                    }
                                                                                    trackPurchaseSuccess(account.orderId, authJson, itemsCart);
                                                                                    popupClose('popup_contract_information');
                                                                                } else {
                                                                                    let errorMessage = Object.values(response.errors)[0];
                                                                                    let commonPopup = document.querySelector('#popup-common-message');
                                                                                    let messageError;
                                                                                    if (errorMessage === 'product.outstock') {
                                                                                        let productPopup = document.querySelector('#popup-product-message');
                                                                                        const errorDetail = Object.values(response.errors)[1] || '';
                                                                                        //productPopup.querySelector('.product_outofstock_name').innerHTML = errorDetail;
                                                                                        popupOpen('popup-product-message');
                                                                                        trackPurchaseFail(errorDetail);
                                                                                    } else {
                                                                                        messageError = document.querySelector('.eth-checkout-btn').getAttribute(`data-${errorMessage}`);
                                                                                        errorMessage = prepareCheckoutError(response, errorMessage, window.CHECKOUT_ERROR_MESSAGES.OUTSTOCK);
                                                                                        popupOpen('popup-common-message');
                                                                                        commonPopup.querySelector('h4').innerHTML = commonPopup.querySelector('h4').getAttribute('data-errorTitle');
                                                                                        commonPopup.querySelector('p').innerHTML = messageError ? messageError : errorMessage;

                                                                                        if (response.errors.hasPendingOrder) {
                                                                                            commonPopup.querySelector('.btn-view').style.display = 'block';
                                                                                        } else {
                                                                                            commonPopup.querySelector('.btn-view').style.display = 'none';
                                                                                        }
                                                                                        trackPurchaseFail(messageError ? messageError : errorMessage);
                                                                                    }

                                                                                }
                                                                                if (loading_bg) loading_bg.style.display = "none";
                                                                                checkoutBtn.removeAttribute('disabled');
                                                                                popupClose('popup_contract_information');
                                                                            }).catch(console.error);
                                                                    }).catch(console.error);
                                                                };

                                                                processGmoOrder();
                                                            } else {
                                                                if (loading_bg) loading_bg.style.display = "none";
                                                                checkoutBtn.removeAttribute('disabled');
                                                                popupClose('popup_contract_information');
                                                            }
                                                        }).catch(console.error);

                                                } else {
                                                    popupOpen('popup-common-verified-phone');
                                                    checkoutBtn.removeAttribute('disabled');
                                                }
                                            }

                                        });
                                }
                            }

                        }
                    });

                });

            }


        }

        async initEth() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            const apiEthUrl = window.ETH_APP_URL + 'api/order/create';
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            const self = this; // Save reference to class instance
            checkoutBtn.onclick = function(e){
                e.preventDefault();
                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }
                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    if (loading_bg) loading_bg.style.display = "none";
                    checkoutBtn.removeAttribute('disabled');
                    return;
                }
                checkoutBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                purchaseCheck().then(purchase => {
                    if (loading_bg) loading_bg.style.display = "none";
                    if (purchase && !purchase.success) {
                        const errorMessage = window.purchase_message && window.purchase_message[purchase.message]
                            ? window.purchase_message[purchase.message]
                            : purchase.message;
                        showToast(errorMessage, 'error', 6000, {
                            limit_value_jpy: purchase.limit_value_jpy,
                            limit_duration_days: purchase.limit_duration_days
                        });
                        checkoutBtn.removeAttribute('disabled');
                        return;
                    }

                    inventoryCheck().then(inventory => {
                        if (loading_bg) loading_bg.style.display = "none";
                        if (inventory && inventory.agePriceRestriction && inventory.agePriceRestriction.blocked) {
                            const reason = inventory.agePriceRestriction.reason || 'age_price_restricted';
                            const ageRestrictionMessage = (window.purchase_message && window.purchase_message[reason])
                                ? window.purchase_message[reason]
                                : reason;
                            showToast(ageRestrictionMessage, 'error', 6000);
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }
                        if (inventory && inventory.purchaseTierRestriction && inventory.purchaseTierRestriction.blocked) {
                            const restriction = inventory.purchaseTierRestriction;
                            const tierRestrictionMessage = getPurchaseTierRestrictionMessage(restriction);
                            showToast(tierRestrictionMessage, 'error', 6000);
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }
                        if (inventory && inventory.outOfStockItems && inventory.outOfStockItems.length > 0) {
                            const productPopup = document.querySelector('#popup-product-message');
                            const itemNames = inventory.outOfStockItems.map(item =>
                                `${item.name} (SKU: ${item.sku})`
                            ).join(', ');
                            popupOpen('popup-product-message');
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }

                        if (inventory && inventory.activeSubs && inventory.activeSubs.length > 0) {
                            popupOpen('popup-active-subs');
                            checkoutBtn.removeAttribute('disabled');
                            return;
                        }

                        if (checkoutBtn.classList.contains('customer-no-card')) {
                            getCardInfo(customerId)
                                .then(isCard => {
                                    if (isCard) {
                                        if (authToken) {
                                            var authJson = JSON.parse(authToken);
                                            if(authJson.access_token) {
                                                getUserInfo(authJson.access_token)
                                                    .then(resData => {
                                                        if (resData){
                                                            if (resData.verify_phone_status){
                                                                if (resData.is_agree_credix_term) {
                                                                    if (loading_bg) loading_bg.style.display = "block";
                                                                    getSection('cart-data')
                                                                        .then((data) => {
                                                                            const response = JSON.parse(data);
                                                                            if (response.items) {
                                                                                var itemsCart = response.items.map(function(item) {
                                                                                    return {
                                                                                        item_id: item.id,
                                                                                        item_name: item.title,
                                                                                        avatar_id: item.id,
                                                                                        avatar_sku: item.sku,
                                                                                        item_brand: item.avatar_type || '',
                                                                                        price: item.price / 100,
                                                                                        quantity: item.quantity
                                                                                    };
                                                                                });
                                                                                if (authToken) {
                                                                                    var authJson = JSON.parse(authToken);
                                                                                }
                                                                                trackCheckOut("ETH", authJson, itemsCart);
                                                                                const saleContract = self.buildSaleContract();
                                                                                if (!saleContract) {
                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                    checkoutBtn.removeAttribute('disabled');
                                                                                    return;
                                                                                }

                                                                                // Check delivery method from button attribute
                                                                                const confirmContractBtn = document.querySelector('#confirm-contract-btn');
                                                                                const deliveryMethod = (confirmContractBtn && confirmContractBtn.getAttribute('data-delivery-method')) || checkoutBtn.getAttribute('data-delivery-method') || 'paper';

                                                                                // Wrap order creation in a function
                                                                                const executeEthOrder = () => {
                                                                                    // Save sale info before creating order
                                                                                    self.saveSaleInfo(saleContract, authJson).then(() => {
                                                                                        const requestBody = { customerId, saleContract, items: response.items };
                                                                                        const affid = getCookie('affid');
                                                                                        const oid = getCookie('oid');
                                                                                        if (affid && oid) {
                                                                                            requestBody.affInfo = { affId: affid, oid: oid };
                                                                                        }
                                                                                        // Continue with order creation
                                                                                        fetch(apiEthUrl, {
                                                                                            method: 'POST',
                                                                                            body: JSON.stringify(requestBody),
                                                                                            headers: {
                                                                                                'Content-Type': 'application/json',
                                                                                                'Accept-Language': Shopify.locale,
                                                                                                'X-Sig': window.sz_config.eth_key,
                                                                                                'X-Epoch': window.sz_config.timestamp
                                                                                            }
                                                                                        })
                                                                                            .then((response) => response.json())
                                                                                            .then((resData) => {
                                                                                                // Only clear cart when order is successfully created (resData.data exists)
                                                                                                if (!resData.errors && resData.data) {
                                                                                                    if (!resData.data.isJpPolicy) {
                                                                                                        popupOpen('popup_non_jp_order_success');
                                                                                                        popupClose('popup_contract_information');
                                                                                                        const qrEl = document.getElementById("eth_nonjp_qrcode");
                                                                                                        if (qrEl) {
                                                                                                            qrEl.innerHTML = '';
                                                                                                            const qr = new QRCode(qrEl, {
                                                                                                                text: resData.data.paymentAddress,
                                                                                                                width: 200,
                                                                                                                height: 200,
                                                                                                            });
                                                                                                            setTimeout(() => {
                                                                                                                const qrImage = document.querySelector('#eth_nonjp_qrcode img');
                                                                                                                if (qrImage) {
                                                                                                                    const downloadBtn = document.getElementById('download-eth-nonjp-qrcode-btn');
                                                                                                                    if (downloadBtn) {
                                                                                                                        downloadBtn.style.display = 'block';
                                                                                                                        downloadBtn.onclick = function() {
                                                                                                                            self.downloadQRCode(qrImage.src);
                                                                                                                        };
                                                                                                                    }
                                                                                                                }
                                                                                                            }, 500);
                                                                                                        }
                                                                                                        self.expireInCountDown(resData.data.expireIn);
                                                                                                        if (document.querySelector('#eth_nonjp_amount')) {
                                                                                                            document.querySelector('#eth_nonjp_amount').innerHTML = resData.data.amount + ' ETH';
                                                                                                        }
                                                                                                        document.querySelector('#eth_nonjp_account_wallet').innerHTML = resData.data.balance + ' ETH';
                                                                                                        document.querySelector('#eth_nonjp_amount_deposited').innerHTML = resData.data.depositAmount + ' ETH';
                                                                                                        if (document.querySelector('#eth_nonjp_summary_estimated_payment')) {
                                                                                                            document.querySelector('#eth_nonjp_summary_estimated_payment').innerHTML = resData.data.ethAmount + ' ETH';
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_nonjp_summary_tax')) {
                                                                                                            document.querySelector('#eth_nonjp_summary_tax').innerHTML = Shopify.formatMoney(resData.data.tax*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_nonjp_summary_orderamount')) {
                                                                                                            document.querySelector('#eth_nonjp_summary_orderamount').innerHTML = Shopify.formatMoney(resData.data.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_nonjp_tranfer_address')) {
                                                                                                            document.querySelector('#eth_nonjp_tranfer_address').innerHTML = resData.data.paymentAddress;
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_nonjp_summary_conversion_rate')) {
                                                                                                            const conversionRate = Shopify.formatMoney(resData.data.convertRate*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                                            document.querySelector('#eth_nonjp_summary_conversion_rate').innerText = `1 ETH ~ ${conversionRate}`;
                                                                                                        }
                                                                                                    } else {
                                                                                                        popupClose('popup_contract_information');
                                                                                                        popupOpen('popup_jp_order_success');

                                                                                                        const qrEl = document.getElementById("eth_qrcode");
                                                                                                        if (qrEl) {
                                                                                                            qrEl.innerHTML = '';
                                                                                                            const qr = new QRCode(qrEl, {
                                                                                                                text: resData.data.paymentAddress,
                                                                                                                width: 200,
                                                                                                                height: 200,
                                                                                                            });
                                                                                                            setTimeout(() => {
                                                                                                                const qrImage = document.querySelector('#eth_qrcode img');
                                                                                                                if (qrImage) {
                                                                                                                    const downloadBtn = document.getElementById('download-eth-qrcode-btn');
                                                                                                                    if (downloadBtn) {
                                                                                                                        downloadBtn.style.display = 'block';
                                                                                                                        downloadBtn.onclick = function() {
                                                                                                                            self.downloadQRCode(qrImage.src);
                                                                                                                        };
                                                                                                                    }
                                                                                                                }
                                                                                                            }, 500);
                                                                                                        }
                                                                                                        self.expireInCountDown(resData.data.expireIn, true);
                                                                                                        if (document.querySelector('#eth_amount_order')) {
                                                                                                            document.querySelector('#eth_amount_order').innerHTML = resData.data.ethAmount + ' ETH';
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_summary_estimated_payment')) {
                                                                                                            document.querySelector('#eth_summary_estimated_payment').innerHTML = resData.data.ethAmount + ' ETH';
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_summary_tax')) {
                                                                                                            document.querySelector('#eth_summary_tax').innerHTML = Shopify.formatMoney(resData.data.tax*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_summary_orderamount')) {
                                                                                                            document.querySelector('#eth_summary_orderamount').innerHTML = Shopify.formatMoney(resData.data.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_tranfer_address')) {
                                                                                                            document.querySelector('#eth_tranfer_address').innerHTML = resData.data.paymentAddress;
                                                                                                        }
                                                                                                        if (document.querySelector('#eth_summary_conversion_rate')) {
                                                                                                            const conversionRate = Shopify.formatMoney(resData.data.convertRate*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                                            document.querySelector('#eth_summary_conversion_rate').innerText = `1 ETH ~ ${conversionRate}`;
                                                                                                        }
                                                                                                    }
                                                                                                    if (typeof trackPurchaseSuccess === 'function') {
                                                                                                        trackPurchaseSuccess(resData.data.orderId, authJson, itemsCart);
                                                                                                    }
                                                                                                    self.checkEthOrderStatus(resData.data.orderId);
                                                                                                    self.initEthCancelButtons(resData.data.orderId);
                                                                                                    ethOrderId = resData.data.orderId;
                                                                                                    if (typeof clearEthCart === 'function') {
                                                                                                        clearEthCart();
                                                                                                    } else {
                                                                                                        fetch(window.Shopify.routes.root + 'cart/clear.js', {
                                                                                                            method: 'POST',
                                                                                                        })
                                                                                                            .then((response) => response.json())
                                                                                                            .then((response) => {
                                                                                                                if(response.item_count === 0) {
                                                                                                                    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                                } else if (!resData.errors && resData.isJpPolicy) {
                                                                                                    // Show popup for JP policy with sale contract when order not yet created
                                                                                                    popupOpen('popup_jp_received_address_sale');
                                                                                                    if (resData.receivedAddress) {
                                                                                                        const receivedAddressInput = document.querySelector('#received-address-sale') || document.querySelector('#received-address');
                                                                                                        if (receivedAddressInput) {
                                                                                                            receivedAddressInput.value = resData.receivedAddress;
                                                                                                        }
                                                                                                    }
                                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                                } else {
                                                                                                    const commonPopup = document.querySelector('#popup-common-message');
                                                                                                    if (resData.errors.hasPending) {
                                                                                                        popupOpen('popup-has-pending');
                                                                                                        if (document.querySelector('#popup-has-pending')) {
                                                                                                            document.querySelector('#popup-has-pending').querySelector('p').innerHTML = resData.errors.hasPending;
                                                                                                        }
                                                                                                    } else {
                                                                                                        let errorMessage = Object.values(resData.errors)[0];
                                                                                                        if (errorMessage === 'customer_must_verify_phone') {
                                                                                                            popupOpen('popup-common-verified-phone');
                                                                                                        } else {
                                                                                                            let messageError;
                                                                                                            if (errorMessage === 'product.outstock') {
                                                                                                                const errorDetail = Object.values(resData.errors)[1] || '';
                                                                                                                popupOpen('popup-product-message');
                                                                                                                if (typeof trackPurchaseFail === 'function') {
                                                                                                                    trackPurchaseFail(errorDetail);
                                                                                                                }
                                                                                                            } else {
                                                                                                                messageError = document.querySelector('.eth-checkout-btn')?.getAttribute(`data-${errorMessage}`);
                                                                                                                if (typeof prepareCheckoutError === 'function') {
                                                                                                                    errorMessage = prepareCheckoutError(resData, errorMessage, window.CHECKOUT_ERROR_MESSAGES?.OUTSTOCK);
                                                                                                                }
                                                                                                                popupOpen('popup-common-message');
                                                                                                                if (commonPopup) {
                                                                                                                    const h4 = commonPopup.querySelector('h4');
                                                                                                                    const p = commonPopup.querySelector('p');
                                                                                                                    if (h4) h4.innerHTML = h4.getAttribute('data-errorTitle') || 'Error';
                                                                                                                    if (p) p.innerHTML = messageError || errorMessage;
                                                                                                                }
                                                                                                                if (typeof trackPurchaseFail === 'function') {
                                                                                                                    trackPurchaseFail(messageError || errorMessage);
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                                }
                                                                                                checkoutBtn.removeAttribute('disabled');
                                                                                            }).catch(console.error);
                                                                                    }).catch(console.error);
                                                                                };

                                                                                // Proceed directly; electronic confirmation is handled via radio change popup
                                                                                executeEthOrder();
                                                                            } else {
                                                                                if (loading_bg) loading_bg.style.display = "none";
                                                                                checkoutBtn.removeAttribute('disabled');
                                                                            }
                                                                        }).catch(console.error);
                                                                } else {
                                                                    popupOpen('popup-common-term-condition');
                                                                    checkoutBtn.removeAttribute('disabled');
                                                                }
                                                            } else {
                                                                popupOpen('popup-common-verified-phone');
                                                                checkoutBtn.removeAttribute('disabled');
                                                            }
                                                        }
                                                    });
                                            }
                                        }
                                    } else {
                                        // No card yet: save sale info before showing secure payment popup
                                        const saleContractNoCard = self.buildSaleContract();
                                        if (!saleContractNoCard) {
                                            if (loading_bg) loading_bg.style.display = "none";
                                            checkoutBtn.removeAttribute('disabled');
                                            return;
                                        }

                                        let authJsonNoCard = null;
                                        if (authToken) {
                                            try {
                                                authJsonNoCard = JSON.parse(authToken);
                                            } catch (err) {
                                                console.error('Error parsing auth token (no-card ETH):', err);
                                            }
                                        }

                                        self.saveSaleInfo(saleContractNoCard, authJsonNoCard)
                                            .catch((error) => {
                                                console.error('Error saving sale info before secure payment (ETH):', error);
                                            })
                                            .finally(() => {
                                                popupOpen('popup-common-secure-payment');
                                                checkoutBtn.removeAttribute('disabled');
                                            });
                                        return;
                                    }
                                });
                        } else {
                            if (authToken) {
                                var authJson = JSON.parse(authToken);
                                if(authJson.access_token) {
                                    getUserInfo(authJson.access_token)
                                        .then(resData => {
                                            if (resData){
                                                if (resData.verify_phone_status){
                                                    if (loading_bg) loading_bg.style.display = "block";
                                                    getSection('cart-data')
                                                        .then((data) => {
                                                            const response = JSON.parse(data);
                                                            if (response.items) {
                                                                var itemsCart = response.items.map(function(item) {
                                                                    return {
                                                                        item_id: item.id,
                                                                        item_name: item.title,
                                                                        avatar_id: item.id,
                                                                        avatar_sku: item.sku,
                                                                        item_brand: item.avatar_type || '',
                                                                        price: item.price / 100,
                                                                        quantity: item.quantity
                                                                    };
                                                                });
                                                                if (authToken) {
                                                                    var authJson = JSON.parse(authToken);
                                                                }
                                                                trackCheckOut("ETH", authJson, itemsCart);
                                                                const saleContract = self.buildSaleContract();
                                                                if (!saleContract) {
                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                    checkoutBtn.removeAttribute('disabled');
                                                                    return;
                                                                }

                                                                // Check delivery method from button attribute
                                                                const confirmContractBtn = document.querySelector('#confirm-contract-btn');
                                                                const deliveryMethod = (confirmContractBtn && confirmContractBtn.getAttribute('data-delivery-method')) || checkoutBtn.getAttribute('data-delivery-method') || 'paper';

                                                                // Wrap order creation in a function
                                                                const executeEthOrder = () => {
                                                                    // Save sale info before creating order
                                                                    self.saveSaleInfo(saleContract, authJson).then(() => {
                                                                        const requestBody = { customerId, saleContract, items: response.items };
                                                                        const affid = getCookie('affid');
                                                                        const oid = getCookie('oid');
                                                                        if (affid && oid) {
                                                                            requestBody.affInfo = { affId: affid, oid: oid };
                                                                        }
                                                                        // Continue with order creation
                                                                        fetch(apiEthUrl, {
                                                                            method: 'POST',
                                                                            body: JSON.stringify(requestBody),
                                                                            headers: {
                                                                                'Content-Type': 'application/json',
                                                                                'Accept-Language': Shopify.locale,
                                                                                'X-Sig': window.sz_config.eth_key,
                                                                                'X-Epoch': window.sz_config.timestamp
                                                                            }
                                                                        })
                                                                            .then((response) => response.json())
                                                                            .then((resData) => {
                                                                                // Only clear cart when order is successfully created (resData.data exists)
                                                                                if (!resData.errors && resData.data) {
                                                                                    if (!resData.data.isJpPolicy) {
                                                                                        popupOpen('popup_non_jp_order_success');
                                                                                        popupClose('popup_contract_information');
                                                                                        const qrEl = document.getElementById("eth_nonjp_qrcode");
                                                                                        if (qrEl) {
                                                                                            qrEl.innerHTML = '';
                                                                                            const qr = new QRCode(qrEl, {
                                                                                                text: resData.data.paymentAddress,
                                                                                                width: 200,
                                                                                                height: 200,
                                                                                            });
                                                                                            setTimeout(() => {
                                                                                                const qrImage = document.querySelector('#eth_nonjp_qrcode img');
                                                                                                if (qrImage) {
                                                                                                    const downloadBtn = document.getElementById('download-eth-nonjp-qrcode-btn');
                                                                                                    if (downloadBtn) {
                                                                                                        downloadBtn.style.display = 'block';
                                                                                                        downloadBtn.onclick = function() {
                                                                                                            self.downloadQRCode(qrImage.src);
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                            }, 500);
                                                                                        }
                                                                                        self.expireInCountDown(resData.data.expireIn);
                                                                                        if (document.querySelector('#eth_nonjp_amount')) {
                                                                                            document.querySelector('#eth_nonjp_amount').innerHTML = resData.data.amount + ' ETH';
                                                                                        }
                                                                                        if (document.querySelector('#eth_nonjp_summary_estimated_payment')) {
                                                                                            document.querySelector('#eth_nonjp_summary_estimated_payment').innerHTML = resData.data.ethAmount + ' ETH';
                                                                                        }
                                                                                        if (document.querySelector('#eth_nonjp_summary_tax')) {
                                                                                            document.querySelector('#eth_nonjp_summary_tax').innerHTML = Shopify.formatMoney(resData.data.tax*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                        }
                                                                                        if (document.querySelector('#eth_nonjp_summary_orderamount')) {
                                                                                            document.querySelector('#eth_nonjp_summary_orderamount').innerHTML = Shopify.formatMoney(resData.data.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                        }
                                                                                        if (document.querySelector('#eth_nonjp_tranfer_address')) {
                                                                                            document.querySelector('#eth_nonjp_tranfer_address').innerHTML = resData.data.paymentAddress;
                                                                                        }
                                                                                        if (document.querySelector('#eth_nonjp_summary_conversion_rate')) {
                                                                                            const conversionRate = Shopify.formatMoney(resData.data.convertRate*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                            document.querySelector('#eth_nonjp_summary_conversion_rate').innerText = `1 ETH ~ ${conversionRate}`;
                                                                                        }
                                                                                    } else {
                                                                                        popupOpen('popup_jp_order_success');
                                                                                        const qrEl = document.getElementById("eth_qrcode");
                                                                                        if (qrEl) {
                                                                                            qrEl.innerHTML = '';
                                                                                            const qr = new QRCode(qrEl, {
                                                                                                text: resData.data.paymentAddress,
                                                                                                width: 200,
                                                                                                height: 200,
                                                                                            });
                                                                                            setTimeout(() => {
                                                                                                const qrImage = document.querySelector('#eth_qrcode img');
                                                                                                if (qrImage) {
                                                                                                    const downloadBtn = document.getElementById('download-eth-qrcode-btn');
                                                                                                    if (downloadBtn) {
                                                                                                        downloadBtn.style.display = 'block';
                                                                                                        downloadBtn.onclick = function() {
                                                                                                            self.downloadQRCode(qrImage.src);
                                                                                                        };
                                                                                                    }
                                                                                                }
                                                                                            }, 500);
                                                                                        }
                                                                                        self.expireInCountDown(resData.data.expireIn, true);
                                                                                        if (document.querySelector('#eth_amount_order')) {
                                                                                            document.querySelector('#eth_amount_order').innerHTML = resData.data.ethAmount + ' ETH';
                                                                                        }
                                                                                        if (document.querySelector('#eth_summary_estimated_payment')) {
                                                                                            document.querySelector('#eth_summary_estimated_payment').innerHTML = resData.data.ethAmount + ' ETH';
                                                                                        }
                                                                                        if (document.querySelector('#eth_summary_tax')) {
                                                                                            document.querySelector('#eth_summary_tax').innerHTML = Shopify.formatMoney(resData.data.tax*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                        }
                                                                                        if (document.querySelector('#eth_summary_orderamount')) {
                                                                                            document.querySelector('#eth_summary_orderamount').innerHTML = Shopify.formatMoney(resData.data.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                        }
                                                                                        if (document.querySelector('#eth_tranfer_address')) {
                                                                                            document.querySelector('#eth_tranfer_address').innerHTML = resData.data.paymentAddress;
                                                                                        }
                                                                                        if (document.querySelector('#eth_summary_conversion_rate')) {
                                                                                            const conversionRate = Shopify.formatMoney(resData.data.convertRate*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                                                            document.querySelector('#eth_summary_conversion_rate').innerText = `1 ETH ~ ${conversionRate}`;
                                                                                        }
                                                                                    }
                                                                                    if (typeof trackPurchaseSuccess === 'function') {
                                                                                        trackPurchaseSuccess(resData.data.orderId, authJson, itemsCart);
                                                                                    }
                                                                                    self.checkEthOrderStatus(resData.data.orderId);
                                                                                    self.initEthCancelButtons(resData.data.orderId);
                                                                                    ethOrderId = resData.data.orderId;
                                                                                    if (typeof clearEthCart === 'function') {
                                                                                        clearEthCart();
                                                                                    } else {
                                                                                        fetch(window.Shopify.routes.root + 'cart/clear.js', {
                                                                                            method: 'POST',
                                                                                        })
                                                                                            .then((response) => response.json())
                                                                                            .then((response) => {
                                                                                                if(response.item_count === 0) {
                                                                                                    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
                                                                                                }
                                                                                            });
                                                                                    }
                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                } else if (!resData.errors && resData.isJpPolicy) {
                                                                                    // Show popup for JP policy with sale contract when order not yet created
                                                                                    popupOpen('popup_jp_received_address_sale');
                                                                                    if (resData.receivedAddress) {
                                                                                        const receivedAddressInput = document.querySelector('#received-address-sale') || document.querySelector('#received-address');
                                                                                        if (receivedAddressInput) {
                                                                                            receivedAddressInput.value = resData.receivedAddress;
                                                                                        }
                                                                                    }
                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                } else {
                                                                                    const commonPopup = document.querySelector('#popup-common-message');
                                                                                    if (resData.errors.hasPending) {
                                                                                        popupOpen('popup-has-pending');
                                                                                        if (document.querySelector('#popup-has-pending')) {
                                                                                            document.querySelector('#popup-has-pending').querySelector('p').innerHTML = resData.errors.hasPending;
                                                                                        }
                                                                                    } else {
                                                                                        let errorMessage = Object.values(resData.errors)[0];
                                                                                        if (errorMessage === 'customer_must_verify_phone') {
                                                                                            popupOpen('popup-common-verified-phone');
                                                                                        } else {
                                                                                            let messageError;
                                                                                            if (errorMessage === 'product.outstock') {
                                                                                                const errorDetail = Object.values(resData.errors)[1] || '';
                                                                                                popupOpen('popup-product-message');
                                                                                                if (typeof trackPurchaseFail === 'function') {
                                                                                                    trackPurchaseFail(errorDetail);
                                                                                                }
                                                                                            } else {
                                                                                                messageError = document.querySelector('.eth-checkout-btn')?.getAttribute(`data-${errorMessage}`);
                                                                                                if (typeof prepareCheckoutError === 'function') {
                                                                                                    errorMessage = prepareCheckoutError(resData, errorMessage, window.CHECKOUT_ERROR_MESSAGES?.OUTSTOCK);
                                                                                                }
                                                                                                popupOpen('popup-common-message');
                                                                                                if (commonPopup) {
                                                                                                    const h4 = commonPopup.querySelector('h4');
                                                                                                    const p = commonPopup.querySelector('p');
                                                                                                    if (h4) h4.innerHTML = h4.getAttribute('data-errorTitle') || 'Error';
                                                                                                    if (p) p.innerHTML = messageError || errorMessage;
                                                                                                }
                                                                                                if (typeof trackPurchaseFail === 'function') {
                                                                                                    trackPurchaseFail(messageError || errorMessage);
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    if (loading_bg) loading_bg.style.display = "none";
                                                                                }
                                                                                checkoutBtn.removeAttribute('disabled');
                                                                            }).catch(console.error);
                                                                    }).catch(console.error);
                                                                };

                                                                // Proceed directly; electronic confirmation is handled via radio change popup
                                                                executeEthOrder();
                                                            } else {
                                                                if (loading_bg) loading_bg.style.display = "none";
                                                                checkoutBtn.removeAttribute('disabled');
                                                            }
                                                        }).catch(console.error);
                                                } else {
                                                    popupOpen('popup-common-verified-phone');
                                                    checkoutBtn.removeAttribute('disabled');
                                                }
                                            }
                                        });
                                }
                            }
                        }
                    });
                });
            };

            // Initialize ETH cancel button handlers (will be called with orderId when order is created)
            this.initEthCancelButtons();

        }

        initEthCancelButtons(orderId = null) {
            const self = this;

            // Store orderId if provided
            if (orderId) {
                this.ethOrderId = orderId;
            }

            const ethCancelBtns = document.querySelectorAll('.cancel-eth-btn');
            const currentOrderId = this.ethOrderId || orderId || window.ethOrderId || null;

            // Handle cancel buttons in popups
            if (ethCancelBtns.length) {
                ethCancelBtns.forEach((btn) => {
                    if (!btn.getAttribute('hasEvent')) {
                        btn.setAttribute('hasEvent', true);
                        btn.addEventListener('click', (e) => {
                            e.preventDefault();
                            const popupResume = btn.closest('.popup-resume');
                            if (popupResume) {
                                popupResume.style.display = 'none';
                            }
                            const orderIdToUse = self.ethOrderId || currentOrderId;
                            if (orderIdToUse) {
                                let ethCancelButton = document.querySelector('#confirm-cancel-ethorder-btn');
                                ethCancelButton.setAttribute('data-order-id', orderIdToUse);
                                popupOpen('popup_eth_cancel_order');
                            }
                        });
                    }
                });
            }

            // Handle confirm cancel button
            const confirmCancelBtn = document.querySelector('#confirm-cancel-ethorder-btn');
            if (confirmCancelBtn && !confirmCancelBtn.getAttribute('hasEvent')) {
                confirmCancelBtn.setAttribute('hasEvent', true);
                confirmCancelBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    popupClose('popup_eth_cancel_order');
                    let cancelOrderId = confirmCancelBtn.getAttribute('data-order-id');
                    if (cancelOrderId) {
                        self.cancelEthOrder(cancelOrderId);
                    }
                });
            }
        }

        async initCredix() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            const self = this; // Save reference to class instance
            checkoutBtn.onclick = function(e) {
                e.preventDefault();

                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }

                // Validate form
                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                checkoutBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                // Get auth token and build sale contract
                var authJson = null;
                if (authToken) {
                    try {
                        authJson = JSON.parse(authToken);
                    } catch (err) {
                        console.error('Error parsing auth token:', err);
                    }
                }

                const saleContract = self.buildSaleContract();
                if (!saleContract) {
                    if (loading_bg) loading_bg.style.display = "none";
                    checkoutBtn.removeAttribute('disabled');
                    return;
                }

                // Check delivery method from button attribute
                const confirmContractBtn = document.querySelector('#confirm-contract-btn');
                const deliveryMethod = (confirmContractBtn && confirmContractBtn.getAttribute('data-delivery-method')) || checkoutBtn.getAttribute('data-delivery-method') || 'paper';

                const trySubmitCreditCardForm = () => {
                    const creditCardComponent = document.querySelector('checkout-creditcard');
                    if (creditCardComponent && typeof creditCardComponent.submitForm === 'function') {
                        const creditCardForm = creditCardComponent.querySelector('#checkout-creditcard-form');
                        if (creditCardForm) {
                            popupClose('popup_contract_information');
                            creditCardComponent.submitForm(creditCardForm);
                            return true;
                        }
                    }
                    return false;
                };

                // Wrap save sale info and redirect/submit logic in a function
                const executeCredixOrder = () => {
                    // Save sale info before continuing
                    self.saveSaleInfo(saleContract, authJson).then(() => {
                        if (loading_bg) loading_bg.style.display = "none";
                        popupClose('popup_contract_information');
                        // If credit card checkout component exists on page, trigger its submit flow
                        // if (trySubmitCreditCardForm()) {
                        //     return;
                        // }
                    }).catch((error) => {
                        console.error('Error saving sale info:', error);
                        if (loading_bg) loading_bg.style.display = "none";

                    });
                };

                // Proceed directly; electronic confirmation is handled via radio change popup
                executeCredixOrder();
            };
        }

        async initCredixType() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            const self = this; // Save reference to class instance
            checkoutBtn.onclick = function(e) {
                e.preventDefault();

                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }

                // Validate form
                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                checkoutBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                // Get auth token and build sale contract
                var authJson = null;
                if (authToken) {
                    try {
                        authJson = JSON.parse(authToken);
                    } catch (err) {
                        console.error('Error parsing auth token:', err);
                    }
                }

                const saleContract = self.buildSaleContract();
                if (!saleContract) {
                    if (loading_bg) loading_bg.style.display = "none";
                    checkoutBtn.removeAttribute('disabled');
                    return;
                }

                // Check delivery method from button attribute
                const confirmContractBtn = document.querySelector('#confirm-contract-btn');
                const deliveryMethod = (confirmContractBtn && confirmContractBtn.getAttribute('data-delivery-method')) || checkoutBtn.getAttribute('data-delivery-method') || 'paper';

                const trySubmitCreditCardForm = () => {
                    const creditCardComponent = document.querySelector('checkout-creditcard');
                    if (creditCardComponent && typeof creditCardComponent.submitForm === 'function') {
                        const creditCardForm = creditCardComponent.querySelector('#checkout-creditcard-form');
                        if (creditCardForm) {
                            popupClose('popup_contract_information');
                            creditCardComponent.submitForm(creditCardForm);
                            return true;
                        }
                    }
                    return false;
                };

                // Wrap save sale info and redirect/submit logic in a function
                const executeCredixOrder = () => {
                    // Save sale info before continuing
                    self.saveSaleInfo(saleContract, authJson).then(() => {
                        if (loading_bg) loading_bg.style.display = "none";
                        popupClose('popup_contract_information');
                        // If credit card checkout component exists on page, trigger its submit flow
                        // if (trySubmitCreditCardForm()) {
                        //     return;
                        // }
                    }).catch((error) => {
                        console.error('Error saving sale info:', error);
                        if (loading_bg) loading_bg.style.display = "none";

                    });
                };

                // Proceed directly; electronic confirmation is handled via radio change popup
                executeCredixOrder();
            };
        }

        async initCredixFirstPurchase() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            const self = this; // Save reference to class instance
            checkoutBtn.onclick = function(e) {
                e.preventDefault();

                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }

                // Validate form
                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                checkoutBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                // Get auth token and build sale contract
                var authJson = null;
                if (authToken) {
                    try {
                        authJson = JSON.parse(authToken);
                    } catch (err) {
                        console.error('Error parsing auth token:', err);
                    }
                }

                const saleContract = self.buildSaleContract();
                if (!saleContract) {
                    if (loading_bg) loading_bg.style.display = "none";
                    checkoutBtn.removeAttribute('disabled');
                    return;
                }

                // Check delivery method from button attribute
                const confirmContractBtn = document.querySelector('#confirm-contract-btn');
                const deliveryMethod = (confirmContractBtn && confirmContractBtn.getAttribute('data-delivery-method')) || checkoutBtn.getAttribute('data-delivery-method') || 'paper';

                // Wrap save sale info and redirect/submit logic in a function
                const executeCredixOrder = () => {
                    // Save sale info before continuing
                    self.saveSaleInfo(saleContract, authJson).then(() => {
                        if (loading_bg) loading_bg.style.display = "none";
                        popupClose('popup_contract_information');
                        window.location = `${Shopify.routes.root}pages/3ds-checkout?salecontract=true`;
                    }).catch((error) => {
                        console.error('Error saving sale info:', error);
                        if (loading_bg) loading_bg.style.display = "none";

                    });
                };

                // Proceed directly; electronic confirmation is handled via radio change popup
                executeCredixOrder();
            };
        }

        async initWeb3() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            const self = this;
            checkoutBtn.onclick = function(e) {
                e.preventDefault();

                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }

                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                checkoutBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                var authJson = null;
                if (authToken) {
                    try {
                        authJson = JSON.parse(authToken);
                    } catch (err) {
                        console.error('Error parsing auth token:', err);
                    }
                }

                const saleContract = self.buildSaleContract();
                if (!saleContract) {
                    if (loading_bg) loading_bg.style.display = "none";
                    checkoutBtn.removeAttribute('disabled');
                    return;
                }

                // Check delivery method from button attribute
                const confirmContractBtn = document.querySelector('#confirm-contract-btn');
                const deliveryMethod = (confirmContractBtn && confirmContractBtn.getAttribute('data-delivery-method')) || checkoutBtn.getAttribute('data-delivery-method') || 'paper';

                const trySubmitWeb3Order = () => {
                    const walletComponent = document.querySelector('checkout-wallet');
                    if (walletComponent && typeof walletComponent.createWeb3Order === 'function') {
                        popupClose('popup_contract_information');
                        walletComponent.createWeb3Order();
                        return true;
                    }
                    return false;
                };

                // Wrap save sale info and redirect/submit logic in a function
                const executeWeb3Order = () => {
                    self.saveSaleInfo(saleContract, authJson).then(() => {
                        if (loading_bg) loading_bg.style.display = "none";
                        if (trySubmitWeb3Order()) {
                            return;
                        }
                        window.location.href = `${window.Shopify.routes.root}pages/checkout-wallet?salecontract=true`;
                    }).catch((error) => {
                        console.error('Error saving sale info:', error);
                        if (loading_bg) loading_bg.style.display = "none";
                        if (!trySubmitWeb3Order()) {
                            window.location.href = `${window.Shopify.routes.root}pages/checkout-wallet?salecontract=true`;
                        }
                    });
                };

                // Proceed directly; electronic confirmation is handled via radio change popup
                executeWeb3Order();
            };
        }

        async initProfileUpdate() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            const self = this;
            checkoutBtn.onclick = function(e) {
                e.preventDefault();

                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }

                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                checkoutBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                var authJson = null;
                if (authToken) {
                    try {
                        authJson = JSON.parse(authToken);
                    } catch (err) {
                        console.error('Error parsing auth token:', err);
                    }
                }

                // Skip is-receiving-contract validation for profile update
                const saleContract = self.buildSaleContract(true);
                if (!saleContract) {
                    if (loading_bg) loading_bg.style.display = "none";
                    checkoutBtn.removeAttribute('disabled');
                    return;
                }

                // Wrap save sale info and redirect/submit logic in a function
                const executeProfile = () => {
                    // Save sale info before continuing
                    self.saveSaleInfo(saleContract, authJson).then(() => {
                        if (loading_bg) loading_bg.style.display = "none";
                        checkoutBtn.removeAttribute('disabled');
                        showToast('Save Success','success',)
                    }).catch((error) => {
                        console.error('Error saving sale info:', error);
                        if (loading_bg) loading_bg.style.display = "none";

                    });
                };

                // Proceed directly; electronic confirmation is handled via radio change popup
                executeProfile();
            };
        }

        async initEditContract() {
            const checkoutBtn = this.form.querySelector('.btn-checkout');
            if (!checkoutBtn) return;

            const customerId = window.meta?.page?.customerId;

            const self = this;
            checkoutBtn.onclick = function(e) {
                e.preventDefault();

                if (!customerId) {
                    window.location.href = window.Shopify.routes.root + 'account';
                    return;
                }

                // Check if this is edit contract flow
                const paymentMethod = checkoutBtn.getAttribute('data-payment-method');
                if (paymentMethod !== 'edit_contract') {
                    return; // Not edit contract flow, let other handlers process
                }

                // Validate form
                if (!self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                // Validate holder-address for paper delivery method
                const formData = new FormData(self.form);
                const deliveryMethod = formData.get('contract_delivery_method') || 'electronic';
                if (deliveryMethod === 'paper' || deliveryMethod === 'electronic') {
                    const addressContentInput = self.form.querySelector('#holder_address_info');
                    const holderAddressInput = self.form.querySelector('#holder-address');
                    let hasValidAddress = false;

                    if (addressContentInput && addressContentInput.value) {
                        const addressValue = addressContentInput.value.trim();
                        if (addressValue !== '' && addressValue !== 'null' && addressValue !== 'undefined') {
                            try {
                                // Try to parse as JSON to validate
                                const parsedAddress = JSON.parse(addressValue);
                                // Check if parsed address is a valid object (not null)
                                hasValidAddress = parsedAddress && typeof parsedAddress === 'object' && parsedAddress !== null;
                            } catch (err) {
                                // If parsing fails, consider it invalid
                                hasValidAddress = false;
                            }
                        }
                    }

                    // Also validate holder-address input (readonly display field)
                    if (holderAddressInput) {
                        const holderAddressValue = holderAddressInput.value.trim();
                        if (!holderAddressValue || holderAddressValue === '') {
                            hasValidAddress = false;
                        }
                    }

                    if (!hasValidAddress) {
                        // Show error message
                        const customerDefaultAddressField = self.form.querySelector('.form-field-address-wrapper');
                        if (customerDefaultAddressField) {
                            let errorMsg = customerDefaultAddressField.querySelector('.address-error-message');
                            if (!errorMsg) {
                                errorMsg = document.createElement('div');
                                errorMsg.className = 'address-error-message';
                                errorMsg.style.color = 'red';
                                errorMsg.style.marginTop = '8px';
                                errorMsg.textContent = theme.strings.contract.msg_recipient_address;
                                customerDefaultAddressField.appendChild(errorMsg);
                            } else {
                                errorMsg.style.display = 'block';
                            }
                        }
                        return;
                    } else {
                        // Hide error message if exists
                        const errorMsg = self.form.querySelector('.address-error-message');
                        if (errorMsg) {
                            errorMsg.style.display = 'none';
                        }
                    }
                }

                // Get contract ID from button attribute
                const contractId = checkoutBtn.getAttribute('data-contract-id');
                if (!contractId) {
                    console.error('Contract ID not found');
                    return;
                }

                // Set contract ID on confirm button and open confirmation popup
                const editConfirmBtn = document.querySelector('#edit-confirm-contract-btn');
                if (editConfirmBtn) {
                    editConfirmBtn.setAttribute('data-contract-id', contractId);
                }

                // Open confirmation popup
                if (typeof popupOpen === 'function') {
                    popupOpen('popup_confirm_contract');
                } else if (typeof window.popupOpen === 'function') {
                    window.popupOpen('popup_confirm_contract');
                }
            };
        }

        async initEditConfirmContract() {
            const editConfirmBtn = document.querySelector('#edit-confirm-contract-btn');
            if (!editConfirmBtn) return;

            const self = this;
            const loading_bg = document.querySelector(".loading_bg");
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            var authJson = null;
            if (authToken) {
                try {
                    authJson = JSON.parse(authToken);
                } catch (err) {
                    console.error('Error parsing auth token:', err);
                }
            }

            // Remove existing listener if any
            if (editConfirmBtn.hasAttribute('data-edit-confirm-listener-attached')) {
                return;
            }
            editConfirmBtn.setAttribute('data-edit-confirm-listener-attached', 'true');

            editConfirmBtn.addEventListener('click', function(e) {
                e.preventDefault();

                // Get contract ID from button attribute
                const contractId = editConfirmBtn.getAttribute('data-contract-id');
                if (!contractId) {
                    console.error('Contract ID not found');
                    return;
                }

                // Validate form before proceeding
                if (!self.form || !self.form.checkValidity()) {
                    self.form.reportValidity();
                    return;
                }

                // Close confirm popup and show validation errors
                if (typeof popupClose === 'function') {
                    popupClose('popup_confirm_contract');
                } else if (typeof window.popupClose === 'function') {
                    window.popupClose('popup_confirm_contract');
                }

                editConfirmBtn.setAttribute('disabled', 'true');
                if (loading_bg) loading_bg.style.display = "block";

                const saleContract = self.buildSaleContract();
                if (!saleContract) {
                    if (loading_bg) loading_bg.style.display = "none";
                    editConfirmBtn.removeAttribute('disabled');
                    return;
                }

                // Prepare API request for updating contract
                const apiUrl = `${window.middleware_api_url}/ams/sale-contract/v1/update`;
                const requestBody = {
                    id: parseInt(contractId),
                    saleContract: saleContract,
                    forceSendMail: true,
                    email: window.customerEmail || ''
                };

                const headers = {
                    'Content-Type': 'application/json',
                    'X-Sig': window.sz_config.middleware_key || '',
                    'X-Epoch': window.sz_config.timestamp || ''
                };

                // Call API to update contract
                fetch(apiUrl, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(requestBody)
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        if (data && data.success === false) {
                            console.error('Contract update failed:', data);
                            if (loading_bg) loading_bg.style.display = "none";
                            editConfirmBtn.removeAttribute('disabled');

                            // Close confirmation popup
                            if (typeof popupClose === 'function') {
                                popupClose('popup_confirm_contract');
                            } else if (typeof window.popupClose === 'function') {
                                window.popupClose('popup_confirm_contract');
                            }

                            // Show error message from API or default message
                            let errorMessage = data.message;
                            
                            // If message is "Editing not allowed for this order sale contract", use translated message
                            if (errorMessage === 'Editing not allowed for this order sale contract') {
                                errorMessage = theme.strings.contract.msg_not_allowed;
                            } else if (errorMessage === 'Order sale contract not found') {
                                errorMessage = theme.strings.contract.msg_not_found;
                            }
                            
                            if (typeof showToast === 'function') {
                                showToast(errorMessage, 'error');
                            } else {
                                alert(errorMessage);
                            }
                            
                            // Close contract information popup after successful update
                            setTimeout(() => {
                                if (typeof popupClose === 'function') {
                                    popupClose('popup_contract_information');
                                } else if (typeof window.popupClose === 'function') {
                                    window.popupClose('popup_contract_information');
                                }

                                // Optionally reload the page or refresh orders
                                window.location.reload();
                            }, 500);
                            return;
                        }

                        editConfirmBtn.removeAttribute('disabled');

                        // Close confirmation popup
                        if (typeof popupClose === 'function') {
                            popupClose('popup_confirm_contract');
                        } else if (typeof window.popupClose === 'function') {
                            window.popupClose('popup_confirm_contract');
                        }

                        // Show success message
                        if (typeof showToast === 'function') {
                            showToast(theme.strings.contract.msg_sale_success, 'success');
                        } else {
                            alert(theme.strings.contract.msg_sale_success);
                        }

                        self.saveSaleInfo(saleContract, authJson).then(() => {
                            console.log('Save Success');
                        }).catch((error) => {
                            console.error('Error saving sale info:', error);
                        });

                        // Close contract information popup after successful update
                        setTimeout(() => {
                            if (typeof popupClose === 'function') {
                                popupClose('popup_contract_information');
                            } else if (typeof window.popupClose === 'function') {
                                window.popupClose('popup_contract_information');
                            }

                            // Optionally reload the page or refresh orders
                            window.location.reload();
                        }, 500);

                        setTimeout(() => {
                            if (loading_bg) loading_bg.style.display = "none";
                        }, 1000);
                    })
                    .catch((error) => {
                        console.error('Error updating contract:', error);
                        if (loading_bg) loading_bg.style.display = "none";
                        editConfirmBtn.removeAttribute('disabled');

                        // Show error message
                        if (typeof showToast === 'function') {
                            showToast('Failed to update contract. Please try again.', 'error');
                        } else {
                            alert('Failed to update contract. Please try again.');
                        }
                    });
            });
        }

        initEthJpCheckoutSale() {
            const ethJpCheckoutBtnSale = document.querySelector('#eth-jp-checkout-btn-sale');
            if (!ethJpCheckoutBtnSale) return;

            if (!ethJpCheckoutBtnSale.getAttribute('hasEvent')) {
                ethJpCheckoutBtnSale.setAttribute('hasEvent', true);
                ethJpCheckoutBtnSale.addEventListener('click', (e) => {
                    e.preventDefault();
                    ethJpCheckoutBtnSale.setAttribute('disabled', 'true');
                    const customerId = window.meta?.page?.customerId;
                    const loading_bg = document.querySelector(".loading_bg");
                    const apiEthUrl = window.ETH_APP_URL + 'api/order/create';
                    var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

                    if (!customerId) {
                        window.location.href = window.Shopify.routes.root + 'account';
                        return;
                    }

                    if (loading_bg) loading_bg.style.display = "block";

                    purchaseCheck().then(purchase => {
                        if (loading_bg) loading_bg.style.display = "none";
                        if (purchase && !purchase.success) {
                            const errorMessage = window.purchase_message && window.purchase_message[purchase.message]
                                ? window.purchase_message[purchase.message]
                                : purchase.message;
                            showToast(errorMessage, 'error', 6000, {
                                limit_value_jpy: purchase.limit_value_jpy,
                                limit_duration_days: purchase.limit_duration_days
                            });
                            ethJpCheckoutBtnSale.removeAttribute('disabled');
                            return;
                        }

                        inventoryCheck().then(inventory => {
                            if (loading_bg) loading_bg.style.display = "none";
                            if (inventory && inventory.agePriceRestriction && inventory.agePriceRestriction.blocked) {
                                const reason = inventory.agePriceRestriction.reason || 'age_price_restricted';
                                const ageRestrictionMessage = (window.purchase_message && window.purchase_message[reason])
                                    ? window.purchase_message[reason]
                                    : reason;
                                showToast(ageRestrictionMessage, 'error', 6000);
                                ethJpCheckoutBtnSale.removeAttribute('disabled');
                                return;
                            }
                            if (inventory && inventory.purchaseTierRestriction && inventory.purchaseTierRestriction.blocked) {
                                const restriction = inventory.purchaseTierRestriction;
                                const tierRestrictionMessage = getPurchaseTierRestrictionMessage(restriction);
                                showToast(tierRestrictionMessage, 'error', 6000);
                                ethJpCheckoutBtnSale.removeAttribute('disabled');
                                return;
                            }
                            if (inventory && inventory.outOfStockItems && inventory.outOfStockItems.length > 0) {
                                const productPopup = document.querySelector('#popup-product-message');
                                const itemNames = inventory.outOfStockItems.map(item =>
                                    `${item.name} (SKU: ${item.sku})`
                                ).join(', ');
                                popupOpen('popup-product-message');
                                ethJpCheckoutBtnSale.removeAttribute('disabled');
                                return;
                            }

                            if (inventory && inventory.activeSubs && inventory.activeSubs.length > 0) {
                                popupOpen('popup-active-subs');
                                ethJpCheckoutBtnSale.removeAttribute('disabled');
                                return;
                            }

                            if (ethJpCheckoutBtnSale.classList.contains('customer-no-card')) {
                                getCardInfo(customerId)
                                    .then(isCard => {
                                        if (isCard) {
                                            if (authToken) {
                                                var authJson = JSON.parse(authToken);
                                                if(authJson.access_token) {
                                                    getUserInfo(authJson.access_token)
                                                        .then(resData => {
                                                            if (resData){
                                                                if (resData.verify_phone_status){
                                                                    if (resData.is_agree_credix_term) {
                                                                        const receivedAddress = document.querySelector('#received-address-sale')?.value || document.querySelector('#received-address')?.value;
                                                                        const receivedAddressErr = document.querySelector('#received-address-sale-error') || document.querySelector('#received-address-error');
                                                                        const receivedAddressValidationErr = document.querySelector('#received-address-sale-validation-error') || document.querySelector('#received-address-validation-error');
                                                                        if (receivedAddress) {
                                                                            if (receivedAddressErr) receivedAddressErr.style.display = 'none';
                                                                            var valid = typeof WAValidator !== 'undefined' ? WAValidator.validate(receivedAddress, 'eth') : true;
                                                                            if (valid) {
                                                                                if (receivedAddressValidationErr) receivedAddressValidationErr.style.display = 'none';
                                                                                this.createEthOrderWithSaleContract(receivedAddress, ethJpCheckoutBtnSale, loading_bg);
                                                                            } else {
                                                                                if (receivedAddressValidationErr) receivedAddressValidationErr.style.display = 'block';
                                                                                ethJpCheckoutBtnSale.removeAttribute('disabled');
                                                                            }
                                                                        } else {
                                                                            if (receivedAddressErr) receivedAddressErr.style.display = 'block';
                                                                            ethJpCheckoutBtnSale.removeAttribute('disabled');
                                                                        }
                                                                    } else {
                                                                        popupOpen('popup-common-term-condition');
                                                                        ethJpCheckoutBtnSale.removeAttribute('disabled');
                                                                    }
                                                                } else {
                                                                    popupOpen('popup-common-verified-phone');
                                                                    ethJpCheckoutBtnSale.removeAttribute('disabled');
                                                                }
                                                            }
                                                        });
                                                }
                                            }
                                        } else {

                                            // No card yet: save sale info before showing secure payment popup
                                            const saleContractNoCard = self.buildSaleContract();
                                            if (!saleContractNoCard) {
                                                if (loading_bg) loading_bg.style.display = "none";
                                                ethJpCheckoutBtnSale.removeAttribute('disabled');
                                                return;
                                            }

                                            let authJsonNoCard = null;
                                            if (authToken) {
                                                try {
                                                    authJsonNoCard = JSON.parse(authToken);
                                                } catch (err) {
                                                    console.error('Error parsing auth token (no-card GMO):', err);
                                                }
                                            }

                                            self.saveSaleInfo(saleContractNoCard, authJsonNoCard)
                                                .catch((error) => {
                                                    console.error('Error saving sale info before secure payment (GMO):', error);
                                                })
                                                .finally(() => {
                                                    popupOpen('popup-common-secure-payment');
                                                    ethJpCheckoutBtnSale.removeAttribute('disabled');
                                                });
                                            return;
                                        }
                                    });
                            } else {
                                const receivedAddress = document.querySelector('#received-address-sale')?.value || document.querySelector('#received-address')?.value;
                                const receivedAddressErr = document.querySelector('#received-address-sale-error') || document.querySelector('#received-address-error');
                                const receivedAddressValidationErr = document.querySelector('#received-address-sale-validation-error') || document.querySelector('#received-address-validation-error');
                                if (receivedAddress) {
                                    if (receivedAddressErr) receivedAddressErr.style.display = 'none';
                                    var valid = typeof WAValidator !== 'undefined' ? WAValidator.validate(receivedAddress, 'eth') : true;
                                    if (valid) {
                                        if (receivedAddressValidationErr) receivedAddressValidationErr.style.display = 'none';
                                        this.createEthOrderWithSaleContract(receivedAddress, ethJpCheckoutBtnSale, loading_bg);
                                    } else {
                                        if (receivedAddressValidationErr) receivedAddressValidationErr.style.display = 'block';
                                        ethJpCheckoutBtnSale.removeAttribute('disabled');
                                    }
                                } else {
                                    if (receivedAddressErr) receivedAddressErr.style.display = 'block';
                                    ethJpCheckoutBtnSale.removeAttribute('disabled');
                                }
                            }
                        });
                    });
                });
            }
        }

        createEthOrderWithSaleContract(receivedAddress, btn, loading_bg) {
            const customerId = window.meta?.page?.customerId;
            const apiEthUrl = window.ETH_APP_URL + 'api/order/create';
            var authToken = getCookie(window.ENV == "DEV"? 'auth-token-test' : 'auth-token');

            if (!customerId) {
                window.location.href = window.Shopify.routes.root + 'account';
                return;
            }

            if (loading_bg) loading_bg.style.display = "block";
            getSection('cart-data')
                .then((data) => {
                    const response = JSON.parse(data);
                    if (response.items) {
                        var itemsCart = response.items.map(function(item) {
                            return {
                                item_id: item.id,
                                item_name: item.title,
                                avatar_id: item.id,
                                avatar_sku: item.sku,
                                item_brand: item.avatar_type || '',
                                price: item.price / 100,
                                quantity: item.quantity
                            };
                        });
                        if (authToken) {
                            var authJson = JSON.parse(authToken);
                        }
                        trackCheckOut("ETH", authJson, itemsCart);
                        const saleContract = this.buildSaleContract();
                        if (!saleContract) {
                            if (loading_bg) loading_bg.style.display = "none";
                            btn.removeAttribute('disabled');
                            return;
                        }

                        // Save sale info before creating order
                        this.saveSaleInfo(saleContract, authJson).then(() => {
                            const requestBody = { customerId, saleContract, items: response.items, receivedAddress };
                            const affid = getCookie('affid');
                            const oid = getCookie('oid');
                            if (affid && oid) {
                                requestBody.affInfo = { affId: affid, oid: oid };
                            }
                            // Continue with order creation
                            fetch(apiEthUrl, {
                                method: 'POST',
                                body: JSON.stringify(requestBody),
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept-Language': Shopify.locale,
                                    'X-Sig': window.sz_config.eth_key,
                                    'X-Epoch': window.sz_config.timestamp
                                }
                            })
                                .then((response) => response.json())
                                .then((resData) => {
                                    // Only clear cart when order is successfully created (resData.data exists)
                                    if (!resData.errors && resData.data) {
                                        if (!resData.data.isJpPolicy) {
                                            popupOpen('popup_non_jp_order_success');
                                            popupClose('popup_jp_received_address_sale');
                                            popupClose('popup_contract_information');
                                            const qrEl = document.getElementById("eth_nonjp_qrcode");
                                            if (qrEl) {
                                                qrEl.innerHTML = '';
                                                const qr = new QRCode(qrEl, {
                                                    text: resData.data.paymentAddress,
                                                    width: 200,
                                                    height: 200,
                                                });
                                                setTimeout(() => {
                                                    const qrImage = document.querySelector('#eth_nonjp_qrcode img');
                                                    if (qrImage) {
                                                        const downloadBtn = document.getElementById('download-eth-nonjp-qrcode-btn');
                                                        if (downloadBtn) {
                                                            downloadBtn.style.display = 'block';
                                                            downloadBtn.onclick = function() {
                                                                this.downloadQRCode(qrImage.src);
                                                            }.bind(this);
                                                        }
                                                    }
                                                }, 500);
                                            }
                                            this.expireInCountDown(resData.data.expireIn);
                                            if (document.querySelector('#eth_nonjp_amount')) {
                                                document.querySelector('#eth_nonjp_amount').innerHTML = resData.data.amount + ' ETH';
                                            }
                                            if (document.querySelector('#eth_nonjp_summary_estimated_payment')) {
                                                document.querySelector('#eth_nonjp_summary_estimated_payment').innerHTML = resData.data.ethAmount + ' ETH';
                                            }
                                            document.querySelector('#eth_nonjp_account_wallet').innerHTML = resData.data.balance + ' ETH';
                                            document.querySelector('#eth_nonjp_amount_deposited').innerHTML = resData.data.depositAmount + ' ETH';
                                            if (document.querySelector('#eth_nonjp_summary_tax')) {
                                                document.querySelector('#eth_nonjp_summary_tax').innerHTML = Shopify.formatMoney(resData.data.tax*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                            }
                                            if (document.querySelector('#eth_nonjp_summary_orderamount')) {
                                                document.querySelector('#eth_nonjp_summary_orderamount').innerHTML = Shopify.formatMoney(resData.data.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                            }
                                            if (document.querySelector('#eth_nonjp_tranfer_address')) {
                                                document.querySelector('#eth_nonjp_tranfer_address').innerHTML = resData.data.paymentAddress;
                                            }
                                            if (document.querySelector('#eth_nonjp_summary_conversion_rate')) {
                                                const conversionRate = Shopify.formatMoney(resData.data.convertRate*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                document.querySelector('#eth_nonjp_summary_conversion_rate').innerText = `1 ETH ~ ${conversionRate}`;
                                            }
                                        } else {
                                            popupOpen('popup_jp_order_success');
                                            popupClose('popup_jp_received_address_sale');
                                            popupClose('popup_contract_information');
                                            const qrEl = document.getElementById("eth_qrcode");
                                            if (qrEl) {
                                                qrEl.innerHTML = '';
                                                const qr = new QRCode(qrEl, {
                                                    text: resData.data.paymentAddress,
                                                    width: 200,
                                                    height: 200,
                                                });
                                                setTimeout(() => {
                                                    const qrImage = document.querySelector('#eth_qrcode img');
                                                    if (qrImage) {
                                                        const downloadBtn = document.getElementById('download-eth-qrcode-btn');
                                                        if (downloadBtn) {
                                                            downloadBtn.style.display = 'block';
                                                            downloadBtn.onclick = function() {
                                                                this.downloadQRCode(qrImage.src);
                                                            }.bind(this);
                                                        }
                                                    }
                                                }, 500);
                                            }
                                            this.expireInCountDown(resData.data.expireIn, true);
                                            if (document.querySelector('#eth_amount_order')) {
                                                document.querySelector('#eth_amount_order').innerHTML = resData.data.ethAmount + ' ETH';
                                            }
                                            if (document.querySelector('#eth_summary_estimated_payment')) {
                                                document.querySelector('#eth_summary_estimated_payment').innerHTML = resData.data.ethAmount + ' ETH';
                                            }
                                            if (document.querySelector('#eth_summary_tax')) {
                                                document.querySelector('#eth_summary_tax').innerHTML = Shopify.formatMoney(resData.data.tax*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                            }
                                            if (document.querySelector('#eth_summary_orderamount')) {
                                                document.querySelector('#eth_summary_orderamount').innerHTML = Shopify.formatMoney(resData.data.totalPrice*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                            }
                                            if (document.querySelector('#eth_tranfer_address')) {
                                                document.querySelector('#eth_tranfer_address').innerHTML = resData.data.paymentAddress;
                                            }
                                            if (document.querySelector('#eth_summary_conversion_rate')) {
                                                const conversionRate = Shopify.formatMoney(resData.data.convertRate*100, "{{amount_no_decimals}}")  + ' ' + resData.data.currency;
                                                document.querySelector('#eth_summary_conversion_rate').innerText = `1 ETH ~ ${conversionRate}`;
                                            }
                                        }
                                        if (typeof trackPurchaseSuccess === 'function') {
                                            trackPurchaseSuccess(resData.data.orderId, authJson, itemsCart);
                                        }
                                        this.checkEthOrderStatus(resData.data.orderId);
                                        this.initEthCancelButtons(resData.data.orderId);
                                        ethOrderId = resData.data.orderId;
                                        if (typeof clearEthCart === 'function') {
                                            clearEthCart();
                                        } else {
                                            fetch(window.Shopify.routes.root + 'cart/clear.js', {
                                                method: 'POST',
                                            })
                                                .then((response) => response.json())
                                                .then((response) => {
                                                    if(response.item_count === 0) {
                                                        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
                                                    }
                                                });
                                        }
                                        if (loading_bg) loading_bg.style.display = "none";
                                    } else if (!resData.errors && resData.isJpPolicy) {
                                        // Show popup for JP policy when order not yet created
                                        popupClose('popup_contract_information');
                                        popupOpen('popup_jp_received_address_sale');
                                        if (resData.receivedAddress) {
                                            const receivedAddressInput = document.querySelector('#received-address-sale') || document.querySelector('#received-address');
                                            if (receivedAddressInput) {
                                                receivedAddressInput.value = resData.receivedAddress;
                                            }
                                        }
                                        if (loading_bg) loading_bg.style.display = "none";
                                    } else {
                                        const commonPopup = document.querySelector('#popup-common-message');
                                        if (resData.errors && resData.errors.hasPending) {
                                            popupOpen('popup-has-pending');
                                            if (document.querySelector('#popup-has-pending')) {
                                                document.querySelector('#popup-has-pending').querySelector('p').innerHTML = resData.errors.hasPending;
                                            }
                                        } else if (resData.errors) {
                                            let errorMessage = Object.values(resData.errors)[0];
                                            if (errorMessage === 'customer_must_verify_phone') {
                                                popupOpen('popup-common-verified-phone');
                                            } else {
                                                let messageError;
                                                if (errorMessage === 'product.outstock') {
                                                    const errorDetail = Object.values(resData.errors)[1] || '';
                                                    popupOpen('popup-product-message');
                                                    if (typeof trackPurchaseFail === 'function') {
                                                        trackPurchaseFail(errorDetail);
                                                    }
                                                } else {
                                                    messageError = document.querySelector('.eth-checkout-btn')?.getAttribute(`data-${errorMessage}`);
                                                    if (typeof prepareCheckoutError === 'function') {
                                                        errorMessage = prepareCheckoutError(resData, errorMessage, window.CHECKOUT_ERROR_MESSAGES?.OUTSTOCK);
                                                    }
                                                    popupOpen('popup-common-message');
                                                    if (commonPopup) {
                                                        const h4 = commonPopup.querySelector('h4');
                                                        const p = commonPopup.querySelector('p');
                                                        if (h4) h4.innerHTML = h4.getAttribute('data-errorTitle') || 'Error';
                                                        if (p) p.innerHTML = messageError || errorMessage;
                                                    }
                                                    if (typeof trackPurchaseFail === 'function') {
                                                        trackPurchaseFail(messageError || errorMessage);
                                                    }
                                                }
                                            }
                                        }
                                        if (loading_bg) loading_bg.style.display = "none";
                                    }
                                    btn.removeAttribute('disabled');
                                    popupClose('popup_contract_information');
                                }).catch(console.error);
                        }).catch(console.error);
                    } else {
                        if (loading_bg) loading_bg.style.display = "none";
                        btn.removeAttribute('disabled');
                        popupClose('popup_contract_information');
                    }
                }).catch(console.error);
        }

        handleChangeAddressClick() {
            // Get holder_address_info from input
            const holderAddressInfoInput = this.form?.querySelector('#holder_address_info');
            let holderAddressInfo = null;

            if (holderAddressInfoInput && holderAddressInfoInput.value) {
                try {
                    holderAddressInfo = typeof holderAddressInfoInput.value === 'string'
                        ? JSON.parse(holderAddressInfoInput.value)
                        : holderAddressInfoInput.value;
                } catch (err) {
                    console.warn('Error parsing holder_address_info:', err);
                }
            }

            // Open edit address contract drawer
            const editAddressDrawer = document.getElementById('edit-address-contract-drawer');
            if (editAddressDrawer) {
                // Re-initialize event listeners in case drawer was reloaded
                editAddressDrawer.removeAttribute('data-listener-attached');
                this.initEditAddressContractPopup();

                const overlay = document.querySelector('.js-overlay');
                if (overlay) {
                    overlay.classList.add('is-visible');
                }
                document.querySelector('#addresses-drawer').setAttribute('open', '');
                document.querySelector('#addresses-drawer').setAttribute('aria-hidden', 'false');
                editAddressDrawer.setAttribute('open', '');
                editAddressDrawer.setAttribute('aria-hidden', 'false');
            }

            // Re-init country-province-selector component after drawer opens
            setTimeout(() => {
                if (window.CountryProvinceSelector && typeof window.CountryProvinceSelector.initAll === 'function') {
                    window.CountryProvinceSelector.initAll();
                }
            }, 50);

            // Populate form with holder_address_info if available
            if (holderAddressInfo) {
                setTimeout(() => {
                    const form = document.querySelector('#edit-address-contract-form');
                    if (form && holderAddressInfo) {
                        // Populate form fields with holder_address_info data
                        const firstNameInput = form.querySelector('#edit-address-contract-first-name');
                        if (firstNameInput) {
                            firstNameInput.value = holderAddressInfo.first_name || '';
                        }

                        const lastNameInput = form.querySelector('#edit-address-contract-last-name');
                        if (lastNameInput) {
                            lastNameInput.value = holderAddressInfo.last_name || '';
                        }

                        const phoneInput = form.querySelector('#edit-address-contract-phone');
                        if (phoneInput) {
                            phoneInput.value = holderAddressInfo.phone || '';
                        }

                        // Handle country and province select (country-province-selector component)
                        const countrySelect = form.querySelector('#edit-address-contract-country');
                        if (countrySelect) {
                            const countryValue = holderAddressInfo.country || '';
                            if (countryValue) {
                                // Set data-default attribute first
                                countrySelect.setAttribute('data-default', countryValue);

                                // Set value
                                countrySelect.value = countryValue;

                                // Wait a bit for component to be ready, then trigger change event
                                setTimeout(() => {
                                    // Check if selected option exists and has dataset.provinces
                                    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
                                    if (selectedOption && selectedOption.dataset && selectedOption.dataset.provinces) {
                                        // Trigger change event to load provinces
                                        countrySelect.dispatchEvent(new Event('change', { bubbles: true }));

                                        // Set province after country loads
                                        setTimeout(() => {
                                            const provinceSelect = form.querySelector('#edit-address-contract-province');
                                            if (provinceSelect) {
                                                const provinceValue = holderAddressInfo.province || '';
                                                if (provinceValue) {
                                                    provinceSelect.setAttribute('data-default', provinceValue);
                                                    provinceSelect.value = provinceValue;
                                                }
                                            }
                                        }, 300);
                                    }
                                }, 100);
                            }
                        }

                        const zipInput = form.querySelector('#edit-address-contract-zip');
                        if (zipInput) {
                            zipInput.value = holderAddressInfo.zip || '';
                        }

                        const cityInput = form.querySelector('#edit-address-contract-city');
                        if (cityInput) {
                            cityInput.value = holderAddressInfo.city || '';
                        }

                        const address1Input = form.querySelector('#edit-address-contract-address1');
                        if (address1Input) {
                            address1Input.value = holderAddressInfo.address1 || '';
                        }

                        const address2Input = form.querySelector('#edit-address-contract-address2');
                        if (address2Input) {
                            address2Input.value = holderAddressInfo.address2 || '';
                        }
                    }
                }, 100);
            }
        }

        initEditAddressContractPopup() {
            const drawer = document.getElementById('edit-address-contract-drawer');
            if (!drawer) return;

            const submitBtn = drawer.querySelector('#edit-address-contract-submit-btn');
            const cancelBtn = drawer.querySelector('.js-cancel');
            const closeBtn = drawer.querySelector('.js-close-drawer');
            const otherAddressBtn = drawer.querySelector('#edit-address-contract-other-address-btn');

            // Remove existing listeners if any (to prevent duplicates)
            if (drawer.hasAttribute('data-listener-attached')) {
                // Remove old listeners by cloning buttons (this removes all event listeners)
                if (submitBtn) {
                    const newSubmitBtn = submitBtn.cloneNode(true);
                    submitBtn.parentNode.replaceChild(newSubmitBtn, submitBtn);
                }
                if (cancelBtn) {
                    const newCancelBtn = cancelBtn.cloneNode(true);
                    cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
                }
                if (closeBtn) {
                    const newCloseBtn = closeBtn.cloneNode(true);
                    closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
                }
                if (otherAddressBtn) {
                    const newOtherAddressBtn = otherAddressBtn.cloneNode(true);
                    otherAddressBtn.parentNode.replaceChild(newOtherAddressBtn, otherAddressBtn);
                }
            }
            drawer.setAttribute('data-listener-attached', 'true');

            // Re-query buttons after cloning (in case they were replaced)
            const finalSubmitBtn = drawer.querySelector('#edit-address-contract-submit-btn');
            const finalCancelBtn = drawer.querySelector('.js-cancel');
            const finalCloseBtn = drawer.querySelector('.js-close-drawer');
            const finalOtherAddressBtn = drawer.querySelector('#edit-address-contract-other-address-btn');

            const self = this;

            // Handle other address button
            if (finalOtherAddressBtn) {
                finalOtherAddressBtn.addEventListener('click', function(e) {
                    e.preventDefault();

                    // Close edit address contract drawer
                    if (CustomerAddresses && typeof CustomerAddresses.closeDrawer === 'function') {
                        CustomerAddresses.closeDrawer(drawer);
                    } else {
                        drawer.removeAttribute('open');
                        drawer.setAttribute('aria-hidden', 'true');
                    }

                    // Open addresses drawer to select other address
                    const addressesDrawer = document.getElementById('addresses-drawer');
                    if (addressesDrawer) {
                        const overlay = document.querySelector('.js-overlay');
                        if (overlay) {
                            overlay.classList.add('is-visible');
                        }
                        addressesDrawer.setAttribute('open', '');
                        addressesDrawer.setAttribute('aria-hidden', 'false');
                    }
                });
            }

            // Handle cancel button
            if (finalCancelBtn) {
                finalCancelBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (CustomerAddresses && typeof CustomerAddresses.closeDrawer === 'function') {
                        CustomerAddresses.closeDrawer(drawer);
                        document.querySelector('#addresses-drawer').removeAttribute('open', '');
                        document.querySelector('#addresses-drawer').setAttribute('aria-hidden', 'true');
                    } else {
                        drawer.removeAttribute('open');
                        drawer.setAttribute('aria-hidden', 'true');
                        document.querySelector('#addresses-drawer').removeAttribute('open', '');
                        document.querySelector('#addresses-drawer').setAttribute('aria-hidden', 'true');
                        const overlay = document.querySelector('.js-overlay');
                        if (overlay) {
                            overlay.classList.remove('is-visible');
                        }
                    }
                });
            }

            // Handle close button
            if (finalCloseBtn) {
                finalCloseBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (CustomerAddresses && typeof CustomerAddresses.closeDrawer === 'function') {
                        CustomerAddresses.closeDrawer(drawer);
                        document.querySelector('#addresses-drawer').removeAttribute('open', '');
                        document.querySelector('#addresses-drawer').setAttribute('aria-hidden', 'true');
                    } else {
                        drawer.removeAttribute('open');
                        drawer.setAttribute('aria-hidden', 'true');
                        document.querySelector('#addresses-drawer').removeAttribute('open', '');
                        document.querySelector('#addresses-drawer').setAttribute('aria-hidden', 'true');
                        const overlay = document.querySelector('.js-overlay');
                        if (overlay) {
                            overlay.classList.remove('is-visible');
                        }
                    }
                });
            }

            // Handle submit button
            if (finalSubmitBtn) {
                finalSubmitBtn.addEventListener('click', function(e) {
                    e.preventDefault();

                    const form = document.querySelector('#edit-address-contract-form');
                    if (!form) return;

                    // Validate form
                    if (!form.checkValidity()) {
                        form.reportValidity();
                        return;
                    }

                    // Get form data
                    const formData = new FormData(form);
                    const countrySelect = form.querySelector('#edit-address-contract-country');
                    const provinceSelect = form.querySelector('#edit-address-contract-province');

                    const addressData = {
                        first_name: formData.get('first_name') || '',
                        last_name: formData.get('last_name') || '',
                        address1: formData.get('address1') || '',
                        address2: formData.get('address2') || '',
                        city: formData.get('city') || '',
                        zip: formData.get('zip') || '',
                        phone: formData.get('phone') || ''
                    };

                    // Get country and province from select elements
                    if (countrySelect) {
                        addressData.country = countrySelect.options[countrySelect.selectedIndex]?.text || '';
                        addressData.country_code = countrySelect.value || '';
                    }

                    if (provinceSelect) {
                        addressData.province = provinceSelect.options[provinceSelect.selectedIndex]?.text || '';
                        addressData.province_code = provinceSelect.value || '';
                    }

                    // Preserve id if exists in holder_address_info
                    const holderAddressInfoInput = self.form?.querySelector('#holder_address_info');
                    if (holderAddressInfoInput && holderAddressInfoInput.value) {
                        try {
                            const existingAddress = typeof holderAddressInfoInput.value === 'string'
                                ? JSON.parse(holderAddressInfoInput.value)
                                : holderAddressInfoInput.value;
                            if (existingAddress && existingAddress.id) {
                                addressData.id = existingAddress.id;
                            }
                        } catch (err) {
                            console.warn('Error parsing existing holder_address_info:', err);
                        }
                    }

                    // Update holder_address_info input
                    if (holderAddressInfoInput) {
                        holderAddressInfoInput.value = JSON.stringify(addressData);
                    }

                    // Update address display
                    self.updateDefaultAddressDisplay(addressData);

                    // Update holder-address input
                    const holderAddressInput = self.form?.querySelector('#holder-address');
                    if (holderAddressInput) {
                        const addressParts = [
                            addressData.address1,
                            addressData.address2,
                            [addressData.city, addressData.province].filter(Boolean).join(', '),
                            addressData.zip,
                            addressData.country
                        ].filter(part => part && part !== '');
                        holderAddressInput.value = addressParts.join(', ');
                    }

                    // Close drawer
                    const editAddressDrawer = document.getElementById('edit-address-contract-drawer');
                    if (editAddressDrawer) {
                        editAddressDrawer.removeAttribute('open');
                        editAddressDrawer.setAttribute('aria-hidden', 'true');
                        document.querySelector('#addresses-drawer').removeAttribute('open', '');
                        document.querySelector('#addresses-drawer').setAttribute('aria-hidden', 'true');
                        // Remove overlay if no other drawer is open
                        const hasOpenDrawer = document.querySelectorAll('side-drawer[open], side-drawer-new[open]').length > 0;
                        if (!hasOpenDrawer) {
                            const overlay = document.querySelector('.js-overlay');
                            if (overlay) {
                                overlay.classList.remove('is-visible');
                            }
                        }

                        // Hide any previous address error message
                        const errorMsg = self.form?.querySelector('.address-error-message');
                        if (errorMsg) {
                            errorMsg.style.display = 'none';
                        }

                        // Re-check delivery fields to update button visibility
                        self.toggleDeliveryFields();
                    }
                });
            }
        }

        handleDefaultAddressUpdate(event) {
            if (!event || !event.detail) return;
            const { addressId, address } = event.detail;

            if (addressId) {
                const hiddenInput = this.querySelector('#default_address');
                if (hiddenInput) {
                    hiddenInput.value = addressId;
                }
            }

            if (address) {
                this.updateDefaultAddressDisplay(address);
                // Update hidden input for address content
                const addressContentInputs = document.querySelectorAll('input[name="holder_address_info"]');
                console.log(addressContentInputs);
                if (addressContentInputs && address) {
                    addressContentInputs.forEach((element) => {
                        element.value = JSON.stringify(address);
                    });
                }

                // Hide any previous address error message once we have a valid address
                const errorMsg = this.form?.querySelector('.address-error-message');
                if (errorMsg) {
                    errorMsg.style.display = 'none';
                }

                // Re-check delivery fields to update button visibility
                this.toggleDeliveryFields();
            }
        }

        updateDefaultAddressDisplay(address) {
            if (!this.addressDisplay) {
                this.addressDisplay = this.querySelector('.customer_default_address address');
            }

            if (this.addressDisplay) {
                const lines = this.getAddressLines(address);
                this.addressDisplay.innerHTML = '';
                lines.forEach(line => {
                    if (!line) return;
                    const div = document.createElement('div');
                    div.textContent = line;
                    this.addressDisplay.appendChild(div);
                });
            }

            // Update holder-address input with formatted address
            if (address) {
                const holderAddressInput = this.form?.querySelector('#holder-address');
                if (holderAddressInput) {
                    // Format address as a single string
                    const addressParts = [
                        address.address1,
                        address.address2,
                        [address.city, address.province].filter(Boolean).join(', '),
                        address.zip,
                        address.country
                    ].filter(part => part && part !== '');

                    if (addressParts.length > 0) {
                        holderAddressInput.value = addressParts.join(', ');
                    }
                }
            }
        }
 
        getAddressLines(address) {
            const lines = [];
            if (!address) return lines;

            const name = address.name || [address.first_name, address.last_name].filter(Boolean).join(' ');
            if (name) {
                lines.push(name);
            }

            // Append phone number if available
            if (address.phone) {
                lines.push(address.phone);
            }

            const addressParts = [
                address.address1,
                address.address2,
                [address.city, address.province].filter(Boolean).join(', '),
                address.zip,
                address.country
            ].filter(part => part && part !== '');

            if (addressParts.length) {
                lines.push(addressParts.join(', '));
            }



            return lines;
        }

        cancelGmoOrder(orderId) {
            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            const apiGmoCancelUrl = `${window.GMO_APP_URL}api/order/cancel`;
            let commonPopup = document.querySelector('#popup-common-message');

            if (loading_bg) loading_bg.style.display = "block";

            fetch(apiGmoCancelUrl, {
                method: 'POST',
                body: JSON.stringify({ customerId, spOrderId: orderId }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': Shopify.locale,
                    'X-Sig': window.sz_config?.gmo_key,
                    'X-Epoch': window.sz_config?.timestamp
                }
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.message) {
                        popupOpen('popup-common-message');
                        if (commonPopup) {
                            commonPopup.querySelector('h4').innerHTML = commonPopup.querySelector('h4').getAttribute('data-successTitle');
                            commonPopup.querySelector('p').innerHTML = response.message;
                        }
                        if (this.gmoOrderCheckStatusInterval) {
                            clearInterval(this.gmoOrderCheckStatusInterval);
                            this.gmoOrderCheckStatusInterval = null;
                        }
                    }
                    if (loading_bg) loading_bg.style.display = "none";
                })
                .catch((error) => {
                    console.error('Error canceling GMO order:', error);
                    if (loading_bg) loading_bg.style.display = "none";
                });
        }

        checkGmoOrderStatus(orderId) {
            const customerId = window.meta?.page?.customerId;
            const apiUrl = `${window.GMO_APP_URL}api/order/status-check/${orderId}?customerId=${customerId}`;

            if (this.gmoOrderCheckStatusInterval) {
                clearInterval(this.gmoOrderCheckStatusInterval);
            }

            this.gmoOrderCheckStatusInterval = setInterval(() => {
                fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': Shopify.locale,
                        'X-Sig': window.sz_config?.gmo_key,
                        'X-Epoch': window.sz_config?.timestamp
                    }
                })
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.orderStatus && parseInt(response.orderStatus) > 0) {
                            popupClose('popup-success');
                            const gmoOrderNumber = document.querySelector('#gmo_order_number');
                            const gmoSuccessTax = document.querySelector('#gmo_success_tax');
                            const gmoSuccessAmount = document.querySelector('#gmo_success_amount');
                            const gmoSuccessDate = document.querySelector('#gmo_success_date');

                            if (gmoOrderNumber) gmoOrderNumber.innerHTML = response.orderNumber;
                            if (gmoSuccessTax) gmoSuccessTax.innerHTML = Shopify.formatMoney(response.tax * 100, "{{amount_no_decimals}}") + ' ' + response.currency;
                            if (gmoSuccessAmount) gmoSuccessAmount.innerHTML = Shopify.formatMoney(response.totalPrice * 100, "{{amount_no_decimals}}") + ' ' + response.currency;
                            if (gmoSuccessDate) gmoSuccessDate.innerHTML = response.orderDate;

                            popupOpen('popup-success-gmo');

                            if (this.gmoOrderCheckStatusInterval) {
                                clearInterval(this.gmoOrderCheckStatusInterval);
                                this.gmoOrderCheckStatusInterval = null;
                            }
                        } else if (response.orderStatus && (response.orderStatus === 9)) {
                            if (this.gmoOrderCheckStatusInterval) {
                                clearInterval(this.gmoOrderCheckStatusInterval);
                                this.gmoOrderCheckStatusInterval = null;
                            }
                            window.location.href = window.Shopify.routes.root + 'account';
                        }
                    })
                    .catch((error) => {
                        console.error('Error checking GMO order status:', error);
                    });
            }, 5000);
        }

        cancelEthOrder(ethOrderId) {
            const customerId = window.meta?.page?.customerId;
            const loading_bg = document.querySelector(".loading_bg");
            const apiEthCancelUrl = `${window.ETH_APP_URL}api/order/cancel`;
            let commonPopup = document.querySelector('#popup-common-message');

            if (loading_bg) loading_bg.style.display = "block";

            fetch(apiEthCancelUrl, {
                method: 'POST',
                body: JSON.stringify({ customerId, spOrderId: ethOrderId }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': Shopify.locale,
                    'X-Sig': window.sz_config?.eth_key,
                    'X-Epoch': window.sz_config?.timestamp
                }
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.message) {
                        popupOpen('popup-common-message');
                        if (commonPopup) {
                            commonPopup.querySelector('h4').innerHTML = commonPopup.querySelector('h4').getAttribute('data-successTitle');
                            commonPopup.querySelector('p').innerHTML = response.message;
                        }
                        if (this.ethOrderCheckStatusInterval) {
                            clearInterval(this.ethOrderCheckStatusInterval);
                            this.ethOrderCheckStatusInterval = null;
                        }
                    }
                    if (loading_bg) loading_bg.style.display = "none";
                })
                .catch((error) => {
                    console.error('Error canceling ETH order:', error);
                    if (loading_bg) loading_bg.style.display = "none";
                });
        }

        checkEthOrderStatus(orderId) {
            const customerId = window.meta?.page?.customerId;
            const apiUrl = `${window.ETH_APP_URL}api/order/status-check/${orderId}?customerId=${customerId}`;

            if (this.ethOrderCheckStatusInterval) {
                clearInterval(this.ethOrderCheckStatusInterval);
            }

            this.ethOrderCheckStatusInterval = setInterval(() => {
                fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': Shopify.locale,
                        'X-Sig': window.sz_config?.eth_key,
                        'X-Epoch': window.sz_config?.timestamp
                    }
                })
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.orderStatus && response.orderStatus === 3) {
                            const ethSuccessOrderNumber = document.querySelector('#eth_success_order_number');
                            const ethSuccessTax = document.querySelector('#eth_success_tax');
                            const ethSuccessAmount = document.querySelector('#eth_success_amount');
                            const ethSuccessToAddress = document.querySelector('#eth_success_toaddress');
                            const ethSuccessTotalPayment = document.querySelector('#eth_success_totalpayment');
                            const ethSuccessConvertRate = document.querySelector('#eth_success_convertrate');
                            const ethSuccessDate = document.querySelector('#eth_success_date');

                            if (ethSuccessOrderNumber) ethSuccessOrderNumber.innerHTML = response.orderNumber;
                            if (ethSuccessTax) ethSuccessTax.innerHTML = Shopify.formatMoney(response.tax * 100, "{{amount_no_decimals}}") + ' ' + response.currency;
                            if (ethSuccessAmount) ethSuccessAmount.innerHTML = Shopify.formatMoney(response.totalPrice * 100, "{{amount_no_decimals}}") + ' ' + response.currency;
                            if (ethSuccessToAddress) ethSuccessToAddress.innerHTML = response.toAddress;
                            if (ethSuccessTotalPayment) ethSuccessTotalPayment.innerHTML = response.ethAmount + ' ETH';
                            if (ethSuccessConvertRate) {
                                const conversionRate = Shopify.formatMoney(response.convertRate * 100, "{{amount_no_decimals}}") + ' ' + response.currency;
                                ethSuccessConvertRate.innerText = `1 ETH ~ ${conversionRate}`;
                            }
                            if (ethSuccessDate) ethSuccessDate.innerHTML = response.orderDate;

                            popupClose('popup_non_jp_order_success');
                            popupClose('popup_jp_order_success');
                            popupOpen('popup-success-eth');

                            if (this.ethOrderCheckStatusInterval) {
                                clearInterval(this.ethOrderCheckStatusInterval);
                                this.ethOrderCheckStatusInterval = null;
                            }
                        } else if (response.orderStatus && (response.orderStatus === 2 || response.orderStatus === 10)) {
                            if (this.ethOrderCheckStatusInterval) {
                                clearInterval(this.ethOrderCheckStatusInterval);
                                this.ethOrderCheckStatusInterval = null;
                            }
                            window.location.href = window.Shopify.routes.root + 'account';
                        }
                    })
                    .catch((error) => {
                        console.error('Error checking ETH order status:', error);
                    });
            }, 5000);
        }

        expireInCountDown(expireIn, isJp = false) {
            var timeLimitInMinutes = expireIn / 60 / 1000;
            var timeLimitInSeconds = timeLimitInMinutes * 60;
            var timerElement = isJp ? document.getElementById('eth_awaiting_payment_order') : document.getElementById('eth_nonjp_awaiting_payment_order');

            if (this.expireTimeInterval) {
                clearInterval(this.expireTimeInterval);
            }

            const self = this;
            function startTimer() {
                timeLimitInSeconds--;
                var minutes = Math.floor(timeLimitInSeconds / 60);
                var seconds = parseInt(timeLimitInSeconds % 60);
                if (timeLimitInSeconds < 0) {
                    if (timerElement) timerElement.textContent = '00:00';
                    if (self.expireTimeInterval) {
                        clearInterval(self.expireTimeInterval);
                        self.expireTimeInterval = null;
                    }
                    if (timerElement) timerElement.textContent = 'Expired!!!';
                    return;
                }
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                if (timerElement) timerElement.textContent = minutes + ':' + seconds;
            }
            this.expireTimeInterval = setInterval(startTimer, 1000);
        }

        downloadQRCode(qrSrc) {
            const a = document.createElement('a');
            a.href = qrSrc;
            a.download = 'qr_code.png';
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

    }
    customElements.define('contract-information', ContractInformation);
}

// Helper function to clear GMO cart (fallback if not defined in main.js)
if (typeof window.clearGmoCart === 'undefined') {
    window.clearGmoCart = function() {
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
        })
            .then((response) => response.json())
            .then((response) => {
                if(response.item_count === 0) {
                    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
                }
            });
    };
}
